<template>
<v-card
    v-if="(seriesSlug === 'absolute' || seriesSlug === 'bone-valley' || seriesSlug === 'graves-county' || seriesSlug === 'war-on-drugs' || seriesSlug === 'earwitness' || seriesSlug === 'earwitness-bv' || seriesSlug === 'erased' || seriesSlug === 'devils-quarry') && cards[seriesSlug][episodeIdentifier]"
    class="mx-auto"
    max-width="900"
    flat
  >

  <v-card-text
    v-if="seriesSlug === 'bone-valley' && episodeIdentifier.startsWith('S1')"
  >
  <v-icon small>mdi-file-outline</v-icon><a href="https://s3.amazonaws.com/media.metarhythm.com/podcaster/1989_trial_transcript_full.pdf">Complete 1989 Trial Transcript (Large file: 2GB)</a>
  </v-card-text>
    <v-container fluid>
      <v-row>
         <v-col
          v-if="seriesSlug === 'graves-county' && episodeIdentifier === 'E0'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/31QOemnCGZI" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'erased' && episodeIdentifier === 'S1E0'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/Yuc6nKOAD9k" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'earwitness-bv' && episodeIdentifier === 'S4E0'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/4mJbV5L_Lhg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'earwitness' && episodeIdentifier === 'S1E0'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/4mJbV5L_Lhg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
         <v-col
          v-if="seriesSlug === 'war-on-drugs' && episodeIdentifier === 'S1E11'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/nT2EFwOhAn8" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'war-on-drugs' && episodeIdentifier === 'S2E0'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/QmCrR4X-n-Y" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'war-on-drugs' && episodeIdentifier === 'S2E1'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/-ZTR0AjD4CA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'war-on-drugs' && episodeIdentifier === 'S2E2'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/f656vWVE858" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'bone-valley' && episodeIdentifier === 'S2E0'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/Ealc1-KrdGk" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>

        <v-card-text
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier.startsWith('S5')"
        >
          <v-icon x-large color="accent">mdi-file-outline</v-icon><a href="https://s3.us-east-1.amazonaws.com/media.metarhythm.com/podcaster/DiPippo_Third_Trial_Complete_Transcript_REDACTED_FINAL.pdf" target="_new" class="text-h4">Complete 2016 Trial Transcript (Large file: 7MB)</a>
        </v-card-text>
        <v-col
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier === 'S5E1'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/Ejonj326amU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier === 'S5E2'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/1LxrWMKaBvo" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier === 'S5E3'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/bDwIhEkXTzM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier === 'S5E4'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/m2h9dCxwsFk" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier === 'S5E5'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/ftQymqhUQZQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier === 'S5E6'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/12ic2TmGM3k" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-if="seriesSlug === 'devils-quarry' && episodeIdentifier === 'S5E7'"
          cols="12"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/rPxe0y5AwDY" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>
        <v-col
          v-for="card in cards[seriesSlug][episodeIdentifier]"
          :key="card.title"
          cols="12"
          :md="card.flex"

        >
          <v-card >
            <v-img
              :src="card.src"
              :height="getHeight(card.height)"
              cover
            >
            </v-img>
             <v-card-subtitle v-html="card.title"></v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="seriesSlug === 'bone-valley' && episodeIdentifier === 'S1E9'"
          cols="12"
        >
          <v-card>
            <video controls :width="getVideoWidth(560)">
              <source src="https://s3.amazonaws.com/media.metarhythm.com/podcaster/leo_2011_hardee.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <v-card-subtitle v-text="videoTextE9"></v-card-subtitle>
          </v-card>
        </v-col>
        <v-col
          v-if="seriesSlug === 'bone-valley' && episodeIdentifier === 'S1E7'"
          cols="12"
        >
          <v-card>
            <audio controls>
              <source src="https://s3.amazonaws.com/media.metarhythm.com/podcaster/jeremy_scott.mp3" type="audio/mpeg">
              Your browser does not support the audio tag.
            </audio>
            <v-card-subtitle v-text="audioTextE7"></v-card-subtitle>
          </v-card>
        </v-col>
        <v-col
          v-if="seriesSlug === 'bone-valley' && episodeIdentifier === 'S1E5'"
          cols="12"
        >
          <v-card>
            <audio controls>
              <source src="https://s3.amazonaws.com/media.metarhythm.com/podcaster/jeremy_phonecall_1_11_05.mp3" type="audio/mpeg">
              Your browser does not support the audio tag.
            </audio>
            <v-card-subtitle v-text="audioTextE5"></v-card-subtitle>
          </v-card>
        </v-col>
       <v-col
          v-if="seriesSlug === 'bone-valley' && episodeIdentifier === 'S1E2'"
          cols="12"
          :md="4"
        >
          <v-card>
            <audio controls>
              <source src="https://s3.amazonaws.com/media.metarhythm.com/podcaster/Shove_it_Over_full.mp3" type="audio/mpeg">
              Your browser does not support the audio tag.
            </audio>
            <v-card-subtitle v-text="audioText"></v-card-subtitle>
          </v-card>
        </v-col>
        <v-col
          v-if="seriesSlug === 'bone-valley' && episodeIdentifier === 'S1E2'"
          cols="12"
          :md="8"
        >
          <iframe :width="getVideoWidth(560)" :height="getVideoHeight(315)" src="https://www.youtube.com/embed/lA6bruIZ0Ak" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
        </v-col>

      </v-row>
    </v-container>
  </v-card>
</template>

<script>

export default {
  name: 'ImageGrid',
  props: { episodeIdentifier: String, seriesSlug: String },
  data: () => ({
      audioText: '"Shove It Over," a lining rhythm learned on a railroad construction camp near Lakeland. Performed by Zora Neale Hurston on June 18, 1939.',
      audioTextE5: 'Recorded phone call between Jeremy Scott and his grandmother, Earline Sandage, following Jeremy\'s interrogation by detectives from the Polk County Sheriff\'s Office about his newly-identified fingerprints lifted from Michelle Schofield\'s vehicle.',
      audioTextE7: 'Jeremy Scott confesses, on tape, to the murder of Michelle Schofield. Statement recorded by Private Investigator Pat McKenna in October 2017.',
      videoTextE9: 'Leo Schofield gives a sermon at Hardee Correctional Institution.',
      cards: {
        'absolute' : {
          'S1E1': [
            { title: 'Matt and Stacy Masters with their family', src: '/absolute/E1a.jpg', flex: 6, height: '500px' },
            { title: 'Matt Masters showing off his tattoos', src: '/absolute/E1b.jpg', flex: 6, height: '500px' },
            { title: 'Wall Street Journal: taser stock going through the roof', src: '/absolute/E1c.jpg', flex: 6, height: '500px' },
            { title: 'Dig into the Greg Meyer Taser Collection on the Smithsonian Online Virtual Archives <a href=" https://sova.si.edu/record/nmah.ac.1311?s=0&n=10&t=C&q=Weapons&i=2" target="_new">here</a>', src: '/absolute/E1d.jpg', flex: 6, height: '500px' },
            { title: 'Jack Cover, inventor of the TASER, holding a model of his invention in 1975. Taken from his obituary in the New York Times. Read it <a href="https://www.nytimes.com/2009/02/16/us/16cover.html" target="_new">here</a>.', src: '/absolute/E1e.jpg', flex: 6, height: '500px' },
            { title: '1970\'s news coverage of Jack Cover\'s new invention, the TASER. As taken from Killing Them Safely documentary. See the trailer <a href="https://youtu.be/HkSJ7QinerE" target="_new">here</a>.', src: '/absolute/E1f.jpg', flex: 12, height: '500px' },
            { title: '"Tough Guy Hans Marrero vs. Taser" publicity video for the TASER, c. April 1999', src: '/absolute/E1g.jpg', flex: 12, height: '500px' },
            { title: 'A bull shot with an early version of a taser. See clip <a href="https://www.youtube.com/watch?v=5yIPRDordxE" target="_new">here</a>.', src: '/absolute/E1h.jpg', flex: 12, height: '500px' },
            { title: 'A tribute video to TASER inventor Jack Cover, voice over by Axon\'s corporate historian Steve Tuttle. See more <a href="https://www.youtube.com/watch?v=8i0e35re2gA" target="_new">here</a>.', src: '/absolute/E1i.jpg', flex: 12, height: '500px' },
            { title: 'KTLA News: "Eula Love protests flare up during a meeting of the L.A. Police Commission" (1979). See more <a href="https://www.youtube.com/watch?v=QxOlkX_V_R8&t=214s" target="_new">here</a>.', src: '/absolute/E1j.jpg', flex: 12, height: '500px' },
            { title: 'Rick Smith gives a tour of the modern day TASER HQ in Scottsdale, Arizona. See video <a href="https://www.youtube.com/watch?v=v13rWhHOTZw" target="_new">here</a>.', src: '/absolute/E1k.jpg', flex: 12, height: '500px' },
          ],
          'S1E2' : [
            { title: '2008 Taser International research compendium. View full document <a href="https://ndia.dtic.mil/wp-content/uploads/2008/Intl/TaserInternational.pdf" target="_new">here</a>.', src: '/absolute/E2a.jpg', flex: 6, height: '500px' },
            { title: 'Michael Leonesio, a retired police officer who ran the Oakland (California) Police Department\'s stun gun program.', src: '/absolute/E2b.jpg', flex: 6, height: '500px' },
            { title: 'Taser International\'s earlier product warnings document. See full document <a href="https://www.prisonlegalnews.org/media/publications/taser_warnings_t0_law_enforcement 04_20081.pdf" target="_new">here</a>.', src: '/absolute/E2c.jpg', flex: 6, height: '500px' },
            { title: 'Matt Masters and his KCPD SNU Tac brothers. See more <a href="https://www.sanfranciscopolice.org/sites/default/files/Documents/PoliceCommission/Matt%20Masters%20062117%20presentation%20to%20Commission.pdf" target="_new">here</a>.', src: '/absolute/E2d.jpg', flex: 12, height: '500px' },
            { title: 'The Marshall Project covers the release of Nick\'s film Killing Them Safely in 2015. See article <a href="https://www.themarshallproject.org/2015/11/23/the-filmmaker-who-s-taking-on-taser" target="_new">here</a>.', src: '/absolute/E2e.jpg', flex: 6, height: '500px' },
            { title: 'Columbia Daily Tribune Coverage of Stanley Harlan\'s death after a Taser shock in 2008. See article <a href="https://www.columbiatribune.com/story/news/2008/08/28/man-dead-after-shock-from/21523405007/" target="_new">here</a>.', src: '/absolute/E2f.jpg', flex: 6, height: '500px' },
            { title: 'Mike Leonesio photographed with his collection of Tasers for a Reuters article in 2017.', src: '/absolute/E2g.jpg', flex: 6, height: '500px' },
            { title: 'Taser International Executive Steve Tuttle holds a new Taser model at an exposition.', src: '/absolute/E2h.jpg', flex: 12, height: '500px' },
            { title: 'Taser demonstrations at police departments convinced officers that the weapon was effective.', src: '/absolute/E2i.jpg', flex: 12, height: '500px' },
            { title: 'An itinerary for the 2001 TASER Tactical Conference. See full document <a href="https://www.prisonlegalnews.org/media/publications/taser_2001_tactical_conference_for_law_enforcement_2001.pdf" target="_new">here</a>.', src: '/absolute/E2j.jpg', flex: 6, height: '500px' },
          ],
          'S1E3' : [
            { title: 'Page 1 of a February 2002 bulletin from TASER International addressing concerns about in-custody deaths following the use of the ADVANCED TASER M26. It argues that the TASER is a safer less-lethal weapon and that deaths occurring after its use are generally due to drug overdoses or pre-existing medical conditions, not the TASER itself.', src: '/absolute/E3a.jpg', flex: 6, height: '500px' },
            { title: 'Page 1 of a collection of information related to TASER technology and how to manage its use and media portrayal, as laid out by TASER International\'s Vice President of Communications, Steve Tuttle.', src: '/absolute/E3b.jpg', flex: 6, height: '500px' },
            { title: 'Steve Tuttle\'s notes on how to re-headline news articles.', src: '/absolute/E3c.jpg', flex: 6, height: '500px' },
            { title: '"Shock Tactics" an investigation into the studies behind Taser\'s research compendium. Read more <a href="https://www.reuters.com/investigates/special-report/usa-taser-science/" target="_new">here</a>.', src: '/absolute/E3d.jpg', flex: 12, height: '375px' },
            { title: 'A history and overview of the term "Excited Delirium" and its use. Read more <a href="https://fas.org/publication/excited-delirium-a-fatal-term-laid-to-rest/" target="_new">here</a>.', src: '/absolute/E3e.jpg', flex: 12, height: '375px' },
            { title: 'Bryce Masters in the hospital following his encounter with officer Runnels.', src: '/absolute/E3f.jpg', flex: 12, height: '500px' },
            { title: '2004 coverage of Tasers being used on an elementary school student in Miami. See more <a href="https://www.wfmynews2.com/article/news/police-use-taser-on-6-year-old-at-school/83-402234926" target="_new">here</a>.', src: '/absolute/E3g.jpg', flex: 12, height: '375px' },
            { title: '"Off-duty" cops are hired by Taser International to sell Tasers to municipal police agencies. 2005 coverage by the Associated Press. Read more <a href="https://www.starnewsonline.com/story/news/2005/03/19/tasers-use-of-off-duty-cops-as-trainers-draws-some-fire/30696098007/" target="_new">here</a>.', src: '/absolute/E3h.jpg', flex: 12, height: '500px' },
            { title: 'A 2005 report from the ACLU sounded an early alarm about the company\'s claims on safety. Read report <a href="https://www.charlydmiller.com/LIB08/2005SepACLUStunGunFallacy.pdf" target="_new">here</a>.', src: '/absolute/E3i.jpg', flex: 6, height: '500px' },
            { title: 'An instagram post from Axon (formerly Taser International) about the power output of a taser probe, captioned: "Did you know: One Christmas tree light bulb outputs more than 100 times more current than TASER energy weapons? Learn more about #TRUTHAboutTASER at the link in bio! #TCON #Technology #Christmas #Energy #Axon #ProtectLife"', src: '/absolute/E3j.jpg', flex: 6, height: '500px' },
            { title: 'The Master Instructor Syllabus for 2024. Read more <a href="https://a.storyblok.com/f/198504/x/6e32dd7e92/taser-master-instructor-school-course-syllabus.pdf" target="_new">here</a>.', src: '/absolute/E3k.jpg', flex: 6, height: '500px' },
          ],
          'S1E4' : [
            { title: 'A page out of a training bulletin from TASER International, Inc. dated September 30, 2009, titled "Training Bulletin 15.0 Medical Research Update and Revised Warnings." It focuses on the medical research regarding the effects of TASER Electronic Control Devices (ECDs) on human subjects, particularly concerning acidosis and cardiac effects.', src: '/absolute/E4a.jpg', flex: 6, height: '500px' },
            { title: 'Page 2 of a training bulletin from TASER International, Inc. dated September 30, 2009, titled "Training Bulletin 15.0 Medical Research Update and Revised Warnings." Page focuses on recommended safe target zone.', src: '/absolute/E4b.jpg', flex: 6, height: '500px' },
            { title: 'A slide from Matt Masters\' 20 page presentation about Bryce to San Francisco Police Department.', src: '/absolute/E4c.jpg', flex: 12, height: '500px' },
            { title: 'View of the moment of tasing during the Bryce Masters incident from the vantage point of Bryce\'s cellphone.', src: '/absolute/E4d.jpg', flex: 6, height: '500px' },
            { title: 'View of the moment of tasing during the Bryce Masters incident from the vantage point of Police dashcam.', src: '/absolute/E4e.jpg', flex: 6, height: '500px' },
            { title: 'Original Intercept article about Matt, Stacy, and Bryce Masters. Read article <a href="https://theintercept.com/2016/06/07/tased-in-the-chest-for-23-seconds-dead-for-8-minutes-now-facing-a-lifetime-of-recovery/" target="_new">here</a>.', src: '/absolute/E4f.jpg', flex: 12, height: '375px' },
            { title: 'A 2014 news report from Fox 4 KC about Bryce\'s incident. Read report <a href="https://fox4kc.com/news/search-warrants-shed-light-on-taser-incident-that-hospitalized-bryce-masters/" target="_new">here</a>.', src: '/absolute/E4g.jpg', flex: 12, height: '500px' },
            { title: '17-year-old Darryl Turner died after being stunned by a taser at the grocery store where he worked in 2008. The incident was captured on the store\'s security cameras.', src: '/absolute/E4h.jpg', flex: 12, height: '500px' },
            { title: 'A 2007 Police Magazine article written by Taser Medical Director, around the same time as the release of the X26 Taser model. Read it all <a href="https://www.policemag.com/training/article/15348984/are-tasers-really-non-lethal" target="_new">here</a>.', src: '/absolute/E4i.jpg', flex: 12, height: '500px' },
            { title: 'In September 2015, Independence, MO Police Officer Timothy Runnels was sentenced to 4 years in prison for violating Bryce Masters\' civil rights. Read more <a href="https://www.justice.gov/archives/opa/pr/former-independence-missouri-police-officer-sentenced-48-months-prison-violating-civil-rights" target="_new">here</a>.', src: '/absolute/E4j.jpg', flex: 12, height: '500px' },
          ],
          'S1E5' : [
            { title: 'A clip from "Taser Training V12 Christmas Bulb.pdf" containing a comparison of the amperage of a wall outlet, a Christmas tree bulb, and a TASER output, indicating Taser is weaker than x-mas tree bulb.', src: '/absolute/E5a.jpg', flex: 12, height: '500px' },
            { title: 'A quote pulled from GQ article "Shock and Ow", by Michael Joseph Gross, which delves into the world of Taser International, the company behind the Taser non-lethal weapon. Read the full article <a href="https://www.gq.com/story/shock-ow-taser-protector-axon-company-profile" target="_new">here</a>. ', src: '/absolute/E5b.jpg', flex: 12, height: '500px' },
            { title: 'Security cam footage of Daryl Turner incident, moments before he was tased to death. Dot on shirt indicates where the Taser was being aimed on the victim.', src: '/absolute/E5c.jpg', flex: 12, height: '500px' },
            { title: 'A portion of Rick Smith\'s deposition for the Daryl Turner case.', src: '/absolute/E5d.jpg', flex: 12, height: '500px' },
            { title: 'One of the studies in Matt\'s accordion folder: "Effects of cocaine intoxication on the threshold for stun gun induction of ventricular fibrillation" by the Cleveland Clinic. Read it <a href="https://pubmed.ncbi.nlm.nih.gov/16904553/" target="_new">here</a>.', src: '/absolute/E5e.jpg', flex: 12, height: '500px' },
            { title: 'One of the lawsuits in Matt\'s accordion folder: Butler v Taser International. Read about the case <a href="https://law.justia.com/cases/federal/district-courts/texas/txndce/3:2011cv00030/202418/19/" target="_new">here</a>.', src: '/absolute/E5f.jpg', flex: 12, height: '500px' },
            { title: 'John Burton ran for Governor of California under the Socialist Equality Party during the 2003 recall election for Arnold Schwarzenegger. He came in 14th in a field of 135 candidates, earning 6,748 votes. Read more <a href="https://www.joincalifornia.com/candidate/5133" target="_new">here</a>.', src: '/absolute/E5g.jpg', flex: 12, height: '375px' },
            { title: 'Rick Smith and Medical Director Jeff Ho in Rick\'s library, standing in front of binders of research on the Taser\'s safety and effectiveness.', src: '/absolute/E5h.jpg', flex: 12, height: '375px' },
            { title: 'A study published by Taser International\'s Medical Director Jeff Ho in 2016: "Prolonged TASER use on exhausted humans does not worsen markers of acidosis". Read in full <a href="https://pubmed.ncbi.nlm.nih.gov/19555610/" target="_new">here</a>.', src: '/absolute/E5i.jpg', flex: 12, height: '500px' },
            { title: 'The term "excited delirium" falls out of favor with the medical establishment. Read more about it <a href="https://apnews.com/article/excited-delirium-police-deaths-acep-4760e3cbed181503a2ac747ed5afeef6" target="_new">here</a>.', src: '/absolute/E5j.jpg', flex: 12, height: '500px' },
          ],
          'S1E6' : [
            { title: 'A Complaint Investigation Report from the Oakland Police Department regarding a complaint filed by Steve Tuttle against Officer Michael Leonesio. The complaint, received via email, alleges that Officer Leonesio was working outside without a work permit and using departmental equipment to provide information to outside entities. The report indicates the incident allegedly occurred in Cincinnati, OH on December 13, 2011. The investigation concluded that both allegations, "Conducting Private Business Prohibited Activity on Duty" and "Department Property and Equipment - Misappropriation/Misuse," were unfounded. The report was completed on July 3, 2012.', src: '/absolute/E6a.jpg', flex: 6, height: '500px' },
            { title: 'Page 1 of "TASER TIED TO \'INDEPENDENT\' STUDY THAT BACKS STUN GUN" from The Arizona Republic that discusses the involvement of Taser International in a Department of Defense study about the safety and effectiveness of their stun guns. (by Robert Anglen, May 21, 2005)', src: '/absolute/E6b.jpg', flex: 6, height: '500px' },
            { title: 'Page 1 of the "Stanford Taser Study". A report on Electronic Control Weapons (ECWs), a.k.a. Tasers, submitted to the City of Berkeley in June 2015 by the Stanford Criminal Justice Center. The report examines the potential benefits and consequences of equipping city police with ECWs, focusing on their impact on safety for both officers and citizens. Read full document <a href="https://law.stanford.edu/wp-content/uploads/2015/10/ECW-Final-Draft-2.pdf" target="_new">here</a>.', src: '/absolute/E6c.jpg', flex: 6, height: '500px' },
            { title: 'A snapshot of a webpage from 2012 on the TASER International website, highlighting the number of "lives saved" by TASER devices, totaling 87,233 with a countdown to the "next life saved."', src: '/absolute/E6d.jpg', flex: 12, height: '500px' },
            { title: 'Headline from March 28, 1990 article by Daryl Kelley in Los Angeles Times. Read the full article <a href="https://www.latimes.com/archives/la-xpm-1990-03-28-me-66-story.html" target="_new">here<a>.', src: '/absolute/E6e.jpg', flex: 12, height: '500px' },
            { title: 'Headline from Washington Post article by Drew Harwell from December 3, 2014, discussing body cameras after the Ferguson protests. It highlights Taser International\'s earnings after White House\'s buy of 50,000 body cameras. Read the full article <a href="https://www.washingtonpost.com/news/wonk/wp/2014/12/03/the-body-camera-industry-is-feeling-phenomenal-after-ferguson/" target="_new">here</a>.', src: '/absolute/E6f.jpg', flex: 12, height: '500px' },
            { title: 'Headline from Gizmodo article "The New Tech That Could Turn Police Body Cams Into Nightmare Surveillance Tools". It highlights the question of body cams and the safety and privacy of the public. By Sidney Fussell. Published March 9, 2017. Read the full article <a href="https://gizmodo.com/new-ai-could-turn-police-body-cams-into-nightmare-surve-1792224538" target="_new">here</a>.', src: '/absolute/E6g.jpg', flex: 12, height: '500px' },
            { title: 'Axon Week 2025 in Phoenix, Arizona. Opening Keynote speech with Rick Smith in "Star Trek" outfit. Speech focused on incident response, agency efficiency and officer performance through responsibly developed technology. See the full video <a href="https://www.youtube.com/watch?v=rS9jVfcbXWA" target="_new">here</a>.', src: '/absolute/E6h.jpg', flex: 12, height: '500px' },
            { title: 'Steve Filmer\'s full report on the new Air Taser for 12 News Tonight. See video <a href="https://youtu.be/KGYrmKGORUM" target="_new">here</a>.', src: '/absolute/E6i.jpg', flex: 6, height: '500px' },
            { title: 'A Reuters Special Report: Taser maker Axon has a moving backstory. It\'s mostly a myth. (December 27, 2023) Read more <a href="https://www.reuters.com/investigates/special-report/axon-taser-corporate-governance/" target="_new">here</a>.', src: '/absolute/E6j.jpg', flex: 6, height: '500px' },
          ],
        },
        'erased' : {
          'S1E0': [ ],
        },
        'devils-quarry' : {
          'S5E0': [ ],
          'S5E1': [
            { title: 'Police search the woods near Fields Lane outside Carmel, NY in November 1995. There they find the skeletal remains of Josette Wright, a 12-year-old girl who had gone missing over a year prior.', src: '/devils-quarry/E1a.jpg', flex: 12, height: '500px' },
            { title: 'The missing poster for 12-year-old Josette Wright. She was last seen in October 1994.', src: '/devils-quarry/E1b.jpg', flex: 6, height: '500px' },
            { title: 'The boyfriend who lived with Rachel and her mother after he was released from prison.', src: '/devils-quarry/E1c.jpg', flex: 6, height: '500px' },
            { title: 'Carmel PD detective Pat Castaldo working his side gig as an Elvis impersonator.', src: '/devils-quarry/E1d.jpg', flex: 12, height: '500px' },
            { title: 'The photo of Josette Wright used in her missing poster.', src: '/devils-quarry/E1e.jpg', flex: 6, height: '500px' },
          ],
          'S5E2': [
            { title: 'Anthony often drove down from Carmel to New York City for raves and parties with his friends.', src: '/devils-quarry/E2a.jpg', flex: 6, height: '500px' },
            { title: 'Anthony as a teenager in the mid 90s.', src: '/devils-quarry/E2b.jpg', flex: 6, height: '500px' },
            { title: 'Anthony DiPippo got a job working for his stepfather "Big Larry" Bria\'s waste management business.', src: '/devils-quarry/E2c.jpg', flex: 12, height: '500px' },
            { title: 'Anthony and his best friend Andy Krivak.', src: '/devils-quarry/E2d.jpg', flex: 12, height: '500px' },
          ],
          'S5E3': [
            { title: 'In her statements to police, Denise Rose claimed she saw Andy Krivak and Anthony DiPippo rape and kill Josette Wright in the Krivak’s van. No physical evidence - no hair or skin cells or finger prints - ties the van to the crime that Denise says happened there.', src: '/devils-quarry/E3a.jpg', flex: 12, height: '500px' },
            { title: 'The Putnam County Courthouse, where both Anthony and Andy were convicted in separate jury trials.', src: '/devils-quarry/E3b.jpg', flex: 12, height: '500px' },
            { title: 'The Sears brand knife that was found in the woods near Josette\'s remains. The cops showed this and other evidence to their star witness Denise Rose before she made her statement.', src: '/devils-quarry/E3c.jpg', flex: 12, height: '500px' },
            { title: 'Coverage of Anthony\'s trial in the Putnam Reporter Dispatch on June 3, 1997. He was convicted one week later.', src: '/devils-quarry/E3d.jpg', flex: 6, height: '500px' },
          ],
          'S5E4': [
            { title: 'Shawangunk Correctional Facility, the prison where Anthony spent much of his sentence and taught himself the law.', src: '/devils-quarry/E4a.jpg', flex: 12, height: '375px' },
            { title: 'Anthony started weight training in prison, building up his body. Eventually he gave it up to spend more time saving his own life in the prison law library.', src: '/devils-quarry/E4b.jpg', flex: 6, height: '500px' },
            { title: 'When cops came to tell Susan Wright that the remains of her daughter had been found, the first words out of her mouth were "Oh my God. Howard Gombert killed my daughter."', src: '/devils-quarry/E4c.jpg', flex: 6, height: '500px' },
            { title: 'A neighbor watched Josette get into a red-and-black Pontiac Sunbird with Connecticut plates on the afternoon she disappeared. She picked the driver\'s photo from a police lineup. Detectives found the car, tore it apart looking for evidence — and the list of what they collected was never seen again.', src: '/devils-quarry/E4d.jpg', flex: 12, height: '375px' }
          ],
          'S5E5': [
            { title: 'An aerial photo of Fields Lane taken in 1995. The woods off Fields Lane was a favorite place of Howard Gombert\'s to take his victims. This is the same area where Josette\'s remains were discovered.', src: '/devils-quarry/E5a.jpg', flex: 6, height: '500px' },
            { title: 'Howard Gombert hired Bob Leader to defend him in the rape case brought against him by Rachel R. A few years later, he would also represent Anthony DiPippo in his murder trial - a conflict of interest he never disclosed.', src: '/devils-quarry/E5b.jpg', flex: 6, height: '500px' },
            { title: 'The Putnam County Sheriff\'s Department in the 1990s.', src: '/devils-quarry/E5c.jpg', flex: 12, height: '500px' },
            { title: 'Joe Santoro was serving time in a Connecticut prison when a stranger started bragging about a girl named Josette — and how "two suckers" had taken the fall for what he did. Santoro wrote it all down. That stranger was Howard Gombert.', src: '/devils-quarry/E5d.jpg', flex: 6, height: '500px' },

          ],
          'S5E6': [
            { title: 'Howard Gombert\'s 1987 mugshot, he is 24 years old in this photo. In the decade to follow, at least 6 women would accuse him of violent sexual assault.', src: '/devils-quarry/E6a.jpg', flex: 12, height: '500px' },
            { title: 'Howard Gombert\'s photo for his prison badge in the Connecticut Department of Corrections. He is serving a 30 year sentence for his crimes against Jane and Sarah.', src: '/devils-quarry/E6b.jpg', flex: 12, height: '500px' },
            { title: 'Howard Gombert was sentenced to 30 years for his crimes against Jane and Sarah.', src: '/devils-quarry/E6c.jpg', flex: 12, height: '375px' },
            { title: 'In Connecticut, children under 13 may testify via videotape rather than face the accused in the courtroom. Rachel R. did not get the same consideration in New York about a decade previously, she was made to testify only feet away from her attacker.', src: '/devils-quarry/E6d.jpg', flex: 12, height: '375px' },
          ],
          'S5E7': [
            { title: 'Marc Agnifilo had one shot to convince New York\'s highest court to allow something never done before — introducing a third party\'s criminal history as evidence of innocence.', src: '/devils-quarry/E7a.jpg', flex: 12, height: '500px' },
            { title: 'Anthony and one of his lawyers, Mark Baker. Beloved by his clients and coworkers, Mark Baker passed away suddenly in 2025.', src: '/devils-quarry/E7b.jpg', flex: 12, height: '500px' },
            { title: 'Anthony\'s release from prison in 2016 was covered widely by the press.', src: '/devils-quarry/E7c.jpg', flex: 12, height: '500px' },
            { title: 'Coverage of Anthony\'s release in the Putnam County Press, a local paper.', src: '/devils-quarry/E7d.jpg', flex: 12, height: '500px' },
            { title: 'Coverage of Anthony\'s release in the Journal News, a local paper.', src: '/devils-quarry/E7e.jpg', flex: 12, height: '500px' }
          ],
          'S5E8': [
            { title: 'Anthony being interviewed for this podcast by Paul and producer Kara Kornhaber in August 2025. They sit in Anthony\'s red and black wrestling room, an homage to his boyhood heros of the WWE.', src: '/devils-quarry/E8a.jpg', flex: 12, height: '500px' },
            { title: 'Just as he did to Andy Krivak, Officer Dan Stephens used a polygraph test to trick Jeffrey Deskovic into falsely confessing to a murder. Deskovic spent 16 years in prison before he was eventually exonertated of his wrongful conviction and awarded $41 million in damages.', src: '/devils-quarry/E8b.jpg', flex: 12, height: '500px' },
            { title: 'Jeffrey Deskovic\'s exoneration story, his subsequent legal work and his activism have made him a well-known name in the wrongful conviction community.', src: '/devils-quarry/E8c.jpg', flex: 12, height: '500px' },
            { title: 'Anthony\'s lawyer in his first trial, Bob Leader. Unbeknownst to Anthony, Leader had also been Howard Gombert\'s attorney in Rachel\'s rape case, a conflict of interest that would help Anthony get his second trial. He kept practicing law for many years, and eventually became a judge in Putnam County.', src: '/devils-quarry/E8d.jpg', flex: 12, height: '500px' },
            { title: 'Detective Kevin Douchkoff of the Kent PD took Amy Faranda\'s rape kit in 1994. When Anthony\'s team tried to have it tested to prove the link to Howard Gombert, Kent PD reported that it had been destroyed. Douchkoff later became a judge.', src: '/devils-quarry/E8e.jpg', flex: 6, height: '500px' },
            { title: 'In 2015, Carmel PD detective Pat Castaldo was arrested and charged with three crimes related to police brutality. The charges were later dismissed.', src: '/devils-quarry/E8f.jpg', flex: 6, height: '500px' },
            { title: 'In April 1995, a second girl went missing in Carmel. The last person to see her alive was Howard J. Gombert, Jr.', src: '/devils-quarry/E8g.jpg', flex: 6, height: '500px' },
          ],
          'S6E1': [
            { title: 'Robin Frances Murphy, an aspiring writer who loved punk rock and vampire novels, disappeared from the parking lot of her grocery store checkout job on Palm Sunday, 1995. Her friends and family immediately knew something was wrong -- she had tickets to see the Ramones the next day, something she\'d be loathe to miss. To this day, neither Robin nor her body have ever been found.', src: '/devils-quarry-2/E1a.jpg', flex: 12, height: '500px' },
            { title: 'Robin Murphy worked at the Route 52 Carmel Shoprite as a cashier. Just days before she disappeared, her manager says that she was promoted to working in the pharmacy. She didn\'t show up for her first shift in that new position.', src: '/devils-quarry-2/E1b.jpg', flex: 12, height: '500px' },
            { title: 'Four days after Robin went missing, a group of her coworkers and friends organized a search of the wooded area behind the shopping center where she was last seen. This police report details what they found. By this point, the police had not conducted a search of their own.', src: '/devils-quarry-2/E1c.jpg', flex: 6, height: '500px' },
            { title: 'Two days after Robin Murphy was last seen, police came to her family\'s home to look at her room and talk to her parents. What they noticed was her goth style, interest in dark rock & roll music, and angsty teenage poetry. It would take them several more days to conduct their own search of the area she disappeared from or collect physical evidence.', src: '/devils-quarry-2/E1d.jpg', flex: 6, height: '500px' },
            { title: 'Anthony DiPippo holds the boxes that contain Robin Murphy\'s case file. The production team used the over 3,500 pages in this file as the jumping off point for months of reporting.', src: '/devils-quarry-2/E1e.jpg', flex: 6, height: '500px' },
            { title: 'Robin Murphy\'s case file contains records of early searches, contact with other law enforcement agencies, DNA testing, interviews with people close to Robin, photographs, and much more.', src: '/devils-quarry-2/E1f.jpg', flex: 6, height: '500px' },
            { title: 'The April 11th incident report, one of the first pages in the Robin Murphy police file.', src: '/devils-quarry-2/E1h.jpg', flex: 6, height: '500px' },
          ],
          'S6E2': [
            { title: 'Friends of Gombert\'s remember him as charming and handsome. But they knew a darker side of him as well; he wore Satanic symbols and had been accused of raping multiple young girls. They said he had light-switch temper, and witnessed him in a rage at ripping down Robin\'s missing posters from the laundromat where he worked.', src: '/devils-quarry-2/E2a.jpg', flex: 6, height: '500px' },
            { title: 'The statement given to police by the woman we call Ann Marie in the podcast. Her real name is redacted here and in the podcast.', src: '/devils-quarry-2/E2b.jpg', flex: 6, height: '500px' },
            { title: 'According to the police files and his own statements, Howard Gombert Jr. was the last person to see Robin Murphy. He says they talked about in front of the laundromat where he worked about his ongoing relationship troubles. This photo was taken in 2026.', src: '/devils-quarry-2/E2c.jpg', flex: 12, height: '500px' },
            { title: 'Robin\'s family searched relentlessly for Robin in the days and weeks following her disappearance. Her brother Jay says they found nothing more significant than animal bones.', src: '/devils-quarry-2/E2d.jpg', flex: 12, height: '500px' },
            { title: 'One of Robin\'s favorite books was Remember Me by Christopher Pike. It\'s a novel about a girl who solves her own murder as a ghost. Hauntingly, Robin suggested her good friend James read the book not long before she disappeared.', src: '/devils-quarry-2/E2e.jpg', flex: 6, height: '500px' },
            { title: 'On the seventh day of the Robin Murphy investigation, police ran background checks on multiple people close to her.', src: '/devils-quarry-2/E2f.jpg', flex: 6, height: '500px' },
            { title: 'The graveyard near the Carmel Shoprite (coincidentally where Josette Wright was later buried) was visible from Robin\'s home at the time.', src: '/devils-quarry-2/E2g.jpg', flex: 12, height: '500px' },
          ],
          'S6E3': [
            { title: 'From the New York Times on April 21, 1995 -- almost two weeks after Robin Murphy was last seen. The reporter interviewed Howard Gombert while he was recooperating in his hospital bed from what was described in the police file as an attempted suicide.', src: '/devils-quarry-2/E3a.jpg', flex: 6, height: '500px' },
            { title: 'Howard Gombert Jr. in his hospital bed, recovering from what was described in the police file as an attempted suicide. According to the police records, he was found rambling and incoherent on his father\'s lawn, and in the ambulance he told the EMTs that "the police were after him." The suicide attempt occured less than a week after Robin was last seen.', src: '/devils-quarry-2/E3b.jpg', flex: 6, height: '500px' },
            { title: 'Just days after Gombert was interviewed by the police in his hospital room, his fomer lawyer Bob Leader (who would also go on to represent Anthony DiPippo in the Josette Wright murder trial) sent a letter to the Carmel Police requesting that all further questioning happen in his presence.', src: '/devils-quarry-2/E3c.jpg', flex: 6, height: '500px' },
            { title: 'Robin and her boyfriend, Matt Esposito. Matt worked at the Burger King across the street from the Shoprite where Robin worked. She had plans to see him on the evening of April 9th but never showed up. Robin and Matt shared a love of punk rock music and goth style. They nicknamed eachother "Sid and Nancy" after the bassist of The Sex Pistols.', src: '/devils-quarry-2/E3d.jpg', flex: 6, height: '500px' },
            { title: 'The notes from the police interview with the Burger King manager on April 12th, 1995. This along with the interviews with Marc and Matt served as their alibi for the night Robin went missing.', src: '/devils-quarry-2/E3e.jpg', flex: 12, height: '500px' },
            { title: 'Matt Esposito, Robin\'s boyfriend, fell into despair and drug addiction after Robin went missing. His family moved to Vermont not long after. Matt lost his battle with addiction in 2013.', src: '/devils-quarry-2/E3f.jpg', flex: 6, height: '500px' },
            { title: 'Despite the fact that Josette Wright and Robin Murphy went missing within 6 months of each other from the same small town, the investigators never pursued them as linked cases. Officers investigating Robin\'s case did search the area where Josette\'s body was found, but there was little inter-departmental cooperation between Carmel PD and Putnam County Sherriff\'s Office', src: '/devils-quarry-2/E3g.jpg', flex: 6, height: '500px' },
            { title: 'A handdrawn search map of forest around Fields Lane, where Josette Wright\'s body was found in 1995. After that discovery, the police searched for Robin\'s remains there as well. There was also some confusion at first among people in the town as to which of the two missing girls bodies had been found.', src: '/devils-quarry-2/E3h.jpg', flex: 6, height: '500px' },
          ],
          'S6E4': [
            { title: 'Two years after Robin was last seen, her family was growing increasingly frustrated with the efforts (or lack of effort) by the local police. They took matters into their own hands with a set of new posters and a press conference.', src: '/devils-quarry-2/E4a.jpg', flex: 6, height: '500px' },
            { title: 'Poloroids of Nichols Pond, an area that was searched on November 15th, 1997 on the guidance of a local paranormal investigator.', src: '/devils-quarry-2/E4b.jpg', flex: 6, height: '500px' },
            { title: 'A map of the Carmel area, annotated by Dan Ricci, a local reporter and historian who dedicated years to the search for Robin Murphy.', src: '/devils-quarry-2/E4c.jpg', flex: 12, height: '500px' },
            { title: 'Notes from the police file on the day of the dive at Nichols Pond.', src: '/devils-quarry-2/E4d.jpg', flex: 6, height: '500px' },
            { title: 'Penny Osborne, a paranormal investigator in Putnam County, worked on Robin\'s case with her friend and colleague Dan Ricci for years. Her vision of a skull in Nichols Pond led to police conducting a multi-agency search of the area and a dive with 5 trained professionals.', src: '/devils-quarry-2/E4e.jpg', flex: 6, height: '500px' },
            { title: 'Lorraine Hahn, AKA Strega One, learned how to use her psychic gifts from her Italian grandmother. She submitted multiple pages of notes to the Carmel police on clues she\'d collected about Robin\'s disappearance obtained by doing tarot card pulls and dream analysis.', src: '/devils-quarry-2/E4f.jpg', flex: 6, height: '500px' },
            { title: 'The Robin Murphy police file is full of tips from psychics, mystics, witches, and paranormal investigators.', src: '/devils-quarry-2/E4g.jpg', flex: 6, height: '500px' },
            { title: 'Dan Ricci is a local Putnam historian, social studies teacher, and reporter. His work on the Robin Murphy case went on for years, and his collection of documents and interview notes was an enormous help to our investigation. He still holds hope that Robin\'s cold case will be solved.', src: '/devils-quarry-2/E4h.jpg', flex: 6, height: '500px' },
            { title: 'A pin made to support the search for Robin Murphy. Dan Ricci gave one to reporter Kathleen Horan after their interview.', src: '/devils-quarry-2/E41.jpg', flex: 6, height: '500px' },
          ],
          'S6E5': [
            { title: 'John and Louise Corey, the maternal grandparents of Howard Gombert Jr.', src: '/devils-quarry-2/E5a.jpg', flex: 6, height: '500px' },
            { title: 'In 1948, John murdered Louise while their two-year-old daughter was in the backseat of the car. That traumatized little girl grew up to be Howard\'s mother.', src: '/devils-quarry-2/E5b.jpg', flex: 6, height: '500px' },
            { title: 'Eddie See and Denise Lanza in summer 2026. They were once friends of both Howard Gombert and Rachel R., though they had no idea what was really going on at the time.', src: '/devils-quarry-2/E5c.jpg', flex: 6, height: '500px' },
            { title: 'A boy named Gustavo, a member of Eddie and Denise\'s friend group, in front of the party shed frequented by Howard Gobmert. Eddie says they had a dart board and a pull-out couch inside, plus plenty of beverages. Eddie also says he saw girls there with Howard on multiple occaisions.', src: '/devils-quarry-2/E5d.jpg', flex: 6, height: '500px' },
            { title: 'March 30, 2001 news article about the DNA connection between Robin and one of the pairs of underwear kept in Howard Gombert\'s suitcase. The DNA link was arguably the most important breakthrough in the Robin Murphy case.', src: '/devils-quarry-2/E5e.jpg', flex: 12, height: '500px' },
            { title: 'Carmel PD Detective Brian Karst started working on Robin\'s case in 2000, after Howard Gombert was arrested for the final time. Of all the police officers our team read reports from in the casefile, Detective Karst seemed the most determined to solve Robin\'s cold case. He worked the case until he retired.', src: '/devils-quarry-2/E5f.jpg', flex: 12, height: '500px' },
          ],
          'S6E6': [
            { title: 'A grid map of the area surrounding the Gombert residence, used by police and other local searchers.', src: '/devils-quarry-2/E6a.jpg', flex: 6, height: '500px' },
            { title: 'Jane says if the police were looking to find things that Howard Gobmert was hiding, the attic at his dad\'s house was the best place to look. It was accessible only by climbing a ladder to the second story window.', src: '/devils-quarry-2/E6b.jpg', flex: 6, height: '500px' },
            { title: 'The make shift shelter Howard and Jane were living in on the drive way of Howard Gombert Sr.\'s house.', src: '/devils-quarry-2/E6c.jpg', flex: 12, height: '500px' },
            { title: 'During the warrant search of Howard Gombert Sr.\'s house, police took several video tapes into evidence. We do not know the content of these tapes.', src: '/devils-quarry-2/E6d.jpg', flex: 12, height: '500px' },
            { title: 'Jane describes having to move stacks of newspapers from the kitchen just to have space to cook her meals. This is the state the police saw it in on the day of the warrant search.', src: '/devils-quarry-2/E6e.jpg', flex: 12, height: '500px' },
            { title: 'In the attic, police found a folder full of newspaper clippings related to Robin Murphy\'s disappearance. They also found documents related to Howard\'s ex, Ann Marie.', src: '/devils-quarry-2/E6f.jpg', flex: 12, height: '500px' },
            { title: 'Detective Karst\'s police notes from the day of the warrant search at Howard Gombert Sr.\'s home. On that same day, Howard junior received a visit from Karst in prison.', src: '/devils-quarry-2/E6g.jpg', flex: 6, height: '500px' },
            { title: 'Julia Cowley served with the FBI for 22 years and worked in the Behavioral Analysis unit as a profiler. During her time at the FBI, she investigated violent crime including serial killings and sex offenses, white-collar crime, public corruption, and civil rights. She hosts the podcast The Consult: Real FBI Profilers https://www.truecrimeconsult.com/', src: '/devils-quarry-2/E6h.jpg', flex: 6, height: '500px' },
          ],
        },
        'earwitness-bv' : {
          'S4E0': [ ],
          'S4E1': [
            { title: 'Toforest Johnson in an undated photo prior to his arrest', src: '/earwitness/E1a.png', flex: 6, height: '500px' },
            { title: 'Retired Alabama Attorney General Bill Baxley at his law office, 2021', src: '/earwitness/E1b.png', flex: 6, height: '500px' },
            { title: 'More brand menthol cigarettes and lighter found in Deputy William Hardy\'s pocket after his murder', src: '/earwitness/E1c.png', flex: 6, height: '500px' },
            { title: 'Incident report written by Officer Ricky Sharit indicating the large law enforcement response to the hotel early in the morning of July 19, 1995', src: '/earwitness/E1d.png', flex: 6, height: '500px' },
            { title: 'Deputy Wiliam Hardy\'s obituary in a Birmingham newspaper', src: '/earwitness/E1e.png', flex: 12, height: '500px' },
            { title: 'Crime scene photos taken by law enforcement at the back door of the Crown Sterling suites, where Deputy Hardy was shot, and inside the hotel\'s atrium where Hardy had been sitting at a table, smoking and drinking coffee moments earlier', src: '/earwitness/E1f.png', flex: 6, height: '500px' },
            { title: 'Press release circulated by the Jefferson County Sheriff\'s Office the morning after the murder, listing suspicious vehicles and announcing a reward for information', src: '/earwitness/E1g.jpg', flex: 6, height: '500px' },
            { title: 'Letter from Sheriff Mel Bailey to DA David Barber, requesting help soliciting an additional $10,000 in reward money from the Governor\'s office, written two days after the murder', src: '/earwitness/E1h.png', flex: 6, height: '500px' },
            { title: 'The atrium of the hotel as it looks today, mostly unchanged since 1995 when it was the Crown Sterling Suites', src: '/earwitness/E1i.png', flex: 6, height: '500px' },
            { title: 'Newspaper article announcing Governor Fob James\' $10,000 reward for information about the murder, bringing total reward offer to $20,000', src: '/earwitness/E1j.png', flex: 12, height: '375px' },
            { title: 'The main entrance of the hotel as it looks today, also mostly unchanged since 1995 when it was the Crown Sterling Suites', src: '/earwitness/E1k.png', flex: 6, height: '500px' },
            { title: 'The back door of the hotel where Deputy William Hardy was shot, as it looks today', src: '/earwitness/E1l.png', flex: 6, height: '500px' },
          ],
          'S4E2': [
            { title: 'Retired detective Tony Richardson, 2022', src: '/earwitness/E2a.png', flex: 6, height: '500px' },
            { title: 'Tony Richardson reviews documents during his interview with Beth Shelburne, 2022', src: '/earwitness/E2b.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson\'s cousin, Antonio Green, 2021', src: '/earwitness/E2c.png', flex: 12, height: '500px' },
            { title: 'Police report Detective Tony Richardson wrote after first receiving the tip from Rosa Hardy, Yolanda Chamber\'s mother. The report indicates that Yolanda identified Quintez Wilson and Omar Berry as being involved in the killing.', src: '/earwitness/E2d.png', flex: 6, height: '500px' },
            { title: 'Police report Detective Tony Richardson wrote after first interrogating Ardragus Ford', src: '/earwitness/E2e.png', flex: 6, height: '500px' },
          ],
          'S4E3': [
            { title: 'Yolanda Chambers with her son, Malik', src: '/earwitness/E3a.jpg', flex: 12, height: '500px' },
            { title: 'Yolanda Chambers with her son, Malik', src: '/earwitness/E3b.jpg', flex: 6, height: '500px' },
            { title: 'Yolanda in an undated school picture, around age 10', src: '/earwitness/E3c.jpg', flex: 6, height: '500px' },
            { title: 'The remote site in Bessemer, AL where Yolanda Chambers\' body was discovered on Valentine\'s Day, 2009', src: '/earwitness/E3d.jpg', flex: 6, height: '500px' },
            { title: 'Page from Yolanda Chamber\'s funeral program', src: '/earwitness/E3e.jpg', flex: 6, height: '500px' },
            { title: 'Rosa Hardy at her apartment, 2021', src: '/earwitness/E3f.jpg', flex: 6, height: '500px' },
            { title: 'Callie Greer, at one of her offices in Birmingham, 2021', src: '/earwitness/E3g.jpg', flex: 6, height: '500px' },
            { title: 'An excerpt from the pre-trial hearing where Yolanda Chambers testified on the stand that under pressure from police, she told them whatever they wanted to hear about the murder', src: '/earwitness/E3h.jpg', flex: 6, height: '500px' },
            { title: 'Another excerpt from Yolanda\'s testimony at the pre-trial hearing ', src: '/earwitness/E3i.jpg', flex: 6, height: '500px' },
          ],
          'S4E4' : [
            { title: 'Kenyara Pickett at her home in Birmingham, 2021', src: '/earwitness/E4a.jpg', flex: 6, height: '500px' },
            { title: 'Velonique Sanders at her home in Georgia, 2021', src: '/earwitness/E4b.jpg', flex: 6, height: '500px' },
            { title: 'Stanley Chandler at his home in Birmingham, 2021', src: '/earwitness/E4c.jpg', flex: 12, height: '500px' },
            { title: 'Barbetta "Mama Cat" Hunt at her home in Birmingham, 2021', src: '/earwitness/E4d.jpg', flex: 6, height: '500px' },
            { title: 'Richard Jaffe being interviewed by Beth Shelburne at his offices, 2021', src: '/earwitness/E4e.jpg', flex: 6, height: '500px' },
            { title: 'Polaroids of exterior and interior of Tee\'s taken by detectives during the investigation', src: '/earwitness/E4f.jpg', flex: 6, height: '500px' },
            { title: 'Incident report written by detective Tony Richardson logging the day that Toforest Johnson, Ardragus Ford, Quintez Wilson, and Omar Berry were arrested for Deputy Hardy\'s murder, with "Case Closed" noted in his neat cursive', src: '/earwitness/E4g.jpg', flex: 6, height: '500px' },
            { title: 'Report noting a caller to the special tipline, noting that the houseman at the Crown Sterling Suites, Jerry McDaniel, saw Deputy Hardy stopping "6 black males" trying to enter the back door of the hotel about two hours before he was murdered there', src: '/earwitness/E4h.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article from July 27, 1995, describing Latanya Henderson and Yolanda Chamber\'s intial involvement with police as witnesses. Media does not typically report the names of minors who are questioned by police. It\'s unclear why police released Yolanda and LaTanya\'s names to the media. ', src: '/earwitness/E4i.jpg', flex: 12, height: '375px' },
            { title: 'Newspaper article from August 23, 1995, describing Latanya Henderson\'s arrest for hindering prosecution', src: '/earwitness/E4j.jpg', flex: 6, height: '500px' },
            { title: 'Marshall Kelly Cummings at his home Morris, AL, 2021', src: '/earwitness/E4k.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article from September 1990, profiling then-Jefferson County District Attorney David Barber', src: '/earwitness/E4l.jpg', flex: 12, height: '375px' },
            { title: 'Ardragus Ford\'s black Monte Carlo with broken driver\'s side door, seized and searched by detectives', src: '/earwitness/E4m.jpg', flex: 12, height: '375px' },
          ],
          'S4E5' : [
            { title: 'Toforest Johnson\'s mother, Donna Johnson, 2019', src: '/earwitness/E5a.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson\'s oldest daughter, Shanaye Poole, 2019', src: '/earwitness/E5b.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson\'s immediate family including uncles Elmer Johnson and Donald Johnson, cousin Antonio Green, mother Donna Johnson, brother Ronald, and Ronald\'s young sons', src: '/earwitness/E5c.jpg', flex: 12, height: '500px' },
            { title: 'Jeff Wallace, former prosecutor, who brought cases against Toforest Johnson and Ardragus Ford, photographed at the church he attends in Birmingham, 2021', src: '/earwitness/E5d.jpg', flex: 6, height: '500px' },
            { title: 'Ardragus Ford\'s cousin, Nicole Blount Kirskey, 2021', src: '/earwitness/E5e.jpg', flex: 6, height: '500px' },
            { title: 'The hat Deputy Bill Hardy wore religiously, with a bullet hole through the brim', src: '/earwitness/E5f.jpg', flex: 12, height: '500px' },
            { title: 'Newspaper article on the jury verdict recommending the death penalty for Toforest Johnson', src: '/earwitness/E5g.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article describing the outcome of Ardragus Ford\'s first trial', src: '/earwitness/E5h.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article about the beginning of Toforest Johnson\'s second trial', src: '/earwitness/E5i.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article reporting the results of Toforest\'s first trial', src: '/earwitness/E5j.jpg', flex: 6, height: '500px' },
          ],
          'S4E6' : [
            { title: 'Monique Hicks, one of the jurors who voted for guilt at Toforest Johnson\'s second trial', src: '/earwitness/E6a.jpg', flex: 6, height: '500px' },
            { title: 'Jay Crane, another juror who voted to convict Toforest Johnson', src: '/earwitness/E6b.jpg', flex: 6, height: '500px' },
            { title: 'The $5000 check issued to Violet Ellison', src: '/earwitness/E6c.jpg', flex: 12, height: '375px' },
            { title: 'Acknowledgement of receipt', src: '/earwitness/E6d.jpg', flex: 12, height: '375px' },
            { title: 'Judge Alfred Bahakel\'s court order for payment of $5000 to Violet Ellison, noting that he has been informed Ellison came forward "pursuant to the reward"', src: '/earwitness/E6e.jpg', flex: 6, height: '500px' },
            { title: 'Violet Ellison\'s application for the reward', src: '/earwitness/E6f.jpg', flex: 6, height: '500px' },
            { title: 'A packed courtroom at Toforest Johnson\'s 2019 hearing in Judge Pulliam\'s courtroom to determine whether Violet Ellison\'s secret reward payment amounted to prosecutorial misconduct.', src: '/earwitness/E6g.jpg', flex: 12, height: '500px' },
            { title: 'Toforest consults with attorneys Kathryn Miller and Katherine Moss in Judge Pulliam\'s courtroom in 2019; attorneys Patrick Mulvaney (l) and Ty Alper (r) are in the background', src: '/earwitness/E6h.jpg', flex: 12, height: '500px' },
            { title: 'Toforest and attorney Kathryn Miller at his 2019 hearing', src: '/earwitness/E6i.jpg', flex: 12, height: '500px' },
            { title: 'Violet Ellison takes the stand at Toforest Johnson\'s 2019 court hearing', src: '/earwitness/E6j.jpg', flex: 12, height: '500px' },
            { title: 'The Alabama Judicial Building in Montgomery, housing both the state Supreme Court and Court of Criminal Appeals. Both courts have denied relief to Toforest Johnson.', src: '/earwitness/E6k.jpg', flex: 12, height: '500px' },
            { title: 'The judges of the Alabama Court of Criminal Appeals', src: '/earwitness/E6l.jpg', flex: 12, height: '500px' },
          ],
          'S4E7': [
            { title: 'Murika Wilson at her home in Birmingham, 2022', src: '/earwitness/E7a.jpg', flex: 6, height: '500px' },
            { title: 'Violet Ellison is listed on court documents as a witness for the State at Murika Wilson\'s murder trial', src: '/earwitness/E7b.jpg', flex: 6, height: '500px' },
            { title: 'The judge in Murika Wilson\'s murder trial makes a note in the case file, indicating that she has been acquitted and released', src: '/earwitness/E7c.jpg', flex: 6, height: '500px' },
          ],
          'S4E8': [
            { title: 'Toforest Johnson in an undated photo taken during a prison visit with (L-R) his mother, Donna, his daughter Shanaye Poole, and son Tremaine Perry', src: '/earwitness/E8a.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson in an undated photo taken during a prison visit with (L-R) his daughter Shanaye Poole, daughter Akeriya Lawler, and son Tremaine Perry', src: '/earwitness/E8b.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson in an undated photo taken during a prison visit with his mother, Donna Johnson', src: '/earwitness/E8c.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson in a photo taken during a prison visit with his mother, Donna and son, Tremaine Perry', src: '/earwitness/E8d.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson in an undated photo taken during a prison visit with his mother, Donna', src: '/earwitness/E8e.jpg', flex: 6, height: '500px' },
            { title: 'Four of Toforest\'s children (L-R) Akeriya Lawler, Maurice Myers, Shanaye Poole, Tremaine Perry, photographed in Birmingham, 2021', src: '/earwitness/E8f.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson in an undated photo taken during a prison visit with his sons (L-R), Maurice Myers and Tremaine Perry', src: '/earwitness/E8g.jpg', flex: 12, height: '500px' },
            { title: 'Toforest\'s son Robby Foster, with his family, 2021', src: '/earwitness/E8h.jpg', flex: 6, height: '500px' },
            { title: 'Toforest\'s daughter, Akeriya "Muffin" Lawler, reads one of the letters her dad sent her from prison to Beth, 2021', src: '/earwitness/E8i.jpg', flex: 6, height: '500px' },
            { title: 'One of many colorful envelopes Toforest sent his daughter, Akeriya "Muffin" Lawler, from prison', src: '/earwitness/E8j.jpg', flex: 12, height: '500px' },
            { title: 'A holiday card Toforest sent his daughter from prison when she was a child', src: '/earwitness/E8k.jpg', flex: 12, height: '500px' },
            { title: 'The banner sponsored by Greater Birmingham Ministries, hung on the front of their building, which faced the stadium hosting the 2021 World Games in Birmingham ', src: '/earwitness/E8l.jpg', flex: 6, height: '500px' },
            { title: 'The banner hung in front of the Highlands United Methodist Church at the kickoff for its tour of churches across the state of Alabama', src: '/earwitness/E8m.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper clipping from 2021 about the widespread support for DA Danny Carr\'s call for a new trial for Toforest Johnson', src: '/earwitness/E8n.jpg', flex: 6, height: '500px' },
          ]
        },
        'earwitness' : {
          'S1E0': [ ],
          'S1E1': [
            { title: 'Toforest Johnson in an undated photo prior to his arrest', src: '/earwitness/E1a.png', flex: 6, height: '500px' },
            { title: 'Retired Alabama Attorney General Bill Baxley at his law office, 2021', src: '/earwitness/E1b.png', flex: 6, height: '500px' },
            { title: 'More brand menthol cigarettes and lighter found in Deputy William Hardy\'s pocket after his murder', src: '/earwitness/E1c.png', flex: 6, height: '500px' },
            { title: 'Incident report written by Officer Ricky Sharit indicating the large law enforcement response to the hotel early in the morning of July 19, 1995', src: '/earwitness/E1d.png', flex: 6, height: '500px' },
            { title: 'Deputy Wiliam Hardy\'s obituary in a Birmingham newspaper', src: '/earwitness/E1e.png', flex: 12, height: '500px' },
            { title: 'Crime scene photos taken by law enforcement at the back door of the Crown Sterling suites, where Deputy Hardy was shot, and inside the hotel\'s atrium where Hardy had been sitting at a table, smoking and drinking coffee moments earlier', src: '/earwitness/E1f.png', flex: 6, height: '500px' },
            { title: 'Press release circulated by the Jefferson County Sheriff\'s Office the morning after the murder, listing suspicious vehicles and announcing a reward for information', src: '/earwitness/E1g.jpg', flex: 6, height: '500px' },
            { title: 'Letter from Sheriff Mel Bailey to DA David Barber, requesting help soliciting an additional $10,000 in reward money from the Governor\'s office, written two days after the murder', src: '/earwitness/E1h.png', flex: 6, height: '500px' },
            { title: 'The atrium of the hotel as it looks today, mostly unchanged since 1995 when it was the Crown Sterling Suites', src: '/earwitness/E1i.png', flex: 6, height: '500px' },
            { title: 'Newspaper article announcing Governor Fob James\' $10,000 reward for information about the murder, bringing total reward offer to $20,000', src: '/earwitness/E1j.png', flex: 12, height: '375px' },
            { title: 'The main entrance of the hotel as it looks today, also mostly unchanged since 1995 when it was the Crown Sterling Suites', src: '/earwitness/E1k.png', flex: 6, height: '500px' },
            { title: 'The back door of the hotel where Deputy William Hardy was shot, as it looks today', src: '/earwitness/E1l.png', flex: 6, height: '500px' },
          ],
          'S1E2': [
            { title: 'Retired detective Tony Richardson, 2022', src: '/earwitness/E2a.png', flex: 6, height: '500px' },
            { title: 'Tony Richardson reviews documents during his interview with Beth Shelburne, 2022', src: '/earwitness/E2b.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson\'s cousin, Antonio Green, 2021', src: '/earwitness/E2c.png', flex: 12, height: '500px' },
            { title: 'Police report Detective Tony Richardson wrote after first receiving the tip from Rosa Hardy, Yolanda Chamber\'s mother. The report indicates that Yolanda identified Quintez Wilson and Omar Berry as being involved in the killing.', src: '/earwitness/E2d.png', flex: 6, height: '500px' },
            { title: 'Police report Detective Tony Richardson wrote after first interrogating Ardragus Ford', src: '/earwitness/E2e.png', flex: 6, height: '500px' },
          ],
          'S1E3': [
            { title: 'Yolanda Chambers with her son, Malik', src: '/earwitness/E3a.jpg', flex: 12, height: '500px' },
            { title: 'Yolanda Chambers with her son, Malik', src: '/earwitness/E3b.jpg', flex: 6, height: '500px' },
            { title: 'Yolanda in an undated school picture, around age 10', src: '/earwitness/E3c.jpg', flex: 6, height: '500px' },
            { title: 'The remote site in Bessemer, AL where Yolanda Chambers\' body was discovered on Valentine\'s Day, 2009', src: '/earwitness/E3d.jpg', flex: 6, height: '500px' },
            { title: 'Page from Yolanda Chamber\'s funeral program', src: '/earwitness/E3e.jpg', flex: 6, height: '500px' },
            { title: 'Rosa Hardy at her apartment, 2021', src: '/earwitness/E3f.jpg', flex: 6, height: '500px' },
            { title: 'Callie Greer, at one of her offices in Birmingham, 2021', src: '/earwitness/E3g.jpg', flex: 6, height: '500px' },
            { title: 'An excerpt from the pre-trial hearing where Yolanda Chambers testified on the stand that under pressure from police, she told them whatever they wanted to hear about the murder', src: '/earwitness/E3h.jpg', flex: 6, height: '500px' },
            { title: 'Another excerpt from Yolanda\'s testimony at the pre-trial hearing ', src: '/earwitness/E3i.jpg', flex: 6, height: '500px' },
          ],
          'S1E4' : [
            { title: 'Kenyara Pickett at her home in Birmingham, 2021', src: '/earwitness/E4a.jpg', flex: 6, height: '500px' },
            { title: 'Velonique Sanders at her home in Georgia, 2021', src: '/earwitness/E4b.jpg', flex: 6, height: '500px' },
            { title: 'Stanley Chandler at his home in Birmingham, 2021', src: '/earwitness/E4c.jpg', flex: 12, height: '500px' },
            { title: 'Barbetta "Mama Cat" Hunt at her home in Birmingham, 2021', src: '/earwitness/E4d.jpg', flex: 6, height: '500px' },
            { title: 'Richard Jaffe being interviewed by Beth Shelburne at his offices, 2021', src: '/earwitness/E4e.jpg', flex: 6, height: '500px' },
            { title: 'Polaroids of exterior and interior of Tee\'s taken by detectives during the investigation', src: '/earwitness/E4f.jpg', flex: 6, height: '500px' },
            { title: 'Incident report written by detective Tony Richardson logging the day that Toforest Johnson, Ardragus Ford, Quintez Wilson, and Omar Berry were arrested for Deputy Hardy\'s murder, with "Case Closed" noted in his neat cursive', src: '/earwitness/E4g.jpg', flex: 6, height: '500px' },
            { title: 'Report noting a caller to the special tipline, noting that the houseman at the Crown Sterling Suites, Jerry McDaniel, saw Deputy Hardy stopping "6 black males" trying to enter the back door of the hotel about two hours before he was murdered there', src: '/earwitness/E4h.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article from July 27, 1995, describing Latanya Henderson and Yolanda Chamber\'s intial involvement with police as witnesses. Media does not typically report the names of minors who are questioned by police. It\'s unclear why police released Yolanda and LaTanya\'s names to the media. ', src: '/earwitness/E4i.jpg', flex: 12, height: '375px' },
            { title: 'Newspaper article from August 23, 1995, describing Latanya Henderson\'s arrest for hindering prosecution', src: '/earwitness/E4j.jpg', flex: 6, height: '500px' },
            { title: 'Marshall Kelly Cummings at his home Morris, AL, 2021', src: '/earwitness/E4k.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article from September 1990, profiling then-Jefferson County District Attorney David Barber', src: '/earwitness/E4l.jpg', flex: 12, height: '375px' },
            { title: 'Ardragus Ford\'s black Monte Carlo with broken driver\'s side door, seized and searched by detectives', src: '/earwitness/E4m.jpg', flex: 12, height: '375px' },
          ],
          'S1E5' : [
            { title: 'Toforest Johnson\'s mother, Donna Johnson, 2019', src: '/earwitness/E5a.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson\'s oldest daughter, Shanaye Poole, 2019', src: '/earwitness/E5b.jpg', flex: 6, height: '500px' },
            { title: 'Toforest Johnson\'s immediate family including uncles Elmer Johnson and Donald Johnson, cousin Antonio Green, mother Donna Johnson, brother Ronald, and Ronald\'s young sons', src: '/earwitness/E5c.jpg', flex: 12, height: '500px' },
            { title: 'Jeff Wallace, former prosecutor, who brought cases against Toforest Johnson and Ardragus Ford, photographed at the church he attends in Birmingham, 2021', src: '/earwitness/E5d.jpg', flex: 6, height: '500px' },
            { title: 'Ardragus Ford\'s cousin, Nicole Blount Kirskey, 2021', src: '/earwitness/E5e.jpg', flex: 6, height: '500px' },
            { title: 'The hat Deputy Bill Hardy wore religiously, with a bullet hole through the brim', src: '/earwitness/E5f.jpg', flex: 12, height: '500px' },
            { title: 'Newspaper article on the jury verdict recommending the death penalty for Toforest Johnson', src: '/earwitness/E5g.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article describing the outcome of Ardragus Ford\'s first trial', src: '/earwitness/E5h.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article about the beginning of Toforest Johnson\'s second trial', src: '/earwitness/E5i.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper article reporting the results of Toforest\'s first trial', src: '/earwitness/E5j.jpg', flex: 6, height: '500px' },
          ],
          'S1E6' : [
            { title: 'Monique Hicks, one of the jurors who voted for guilt at Toforest Johnson\'s second trial', src: '/earwitness/E6a.jpg', flex: 6, height: '500px' },
            { title: 'Jay Crane, another juror who voted to convict Toforest Johnson', src: '/earwitness/E6b.jpg', flex: 6, height: '500px' },
            { title: 'The $5000 check issued to Violet Ellison', src: '/earwitness/E6c.jpg', flex: 12, height: '375px' },
            { title: 'Acknowledgement of receipt', src: '/earwitness/E6d.jpg', flex: 12, height: '375px' },
            { title: 'Judge Alfred Bahakel\'s court order for payment of $5000 to Violet Ellison, noting that he has been informed Ellison came forward "pursuant to the reward"', src: '/earwitness/E6e.jpg', flex: 6, height: '500px' },
            { title: 'Violet Ellison\'s application for the reward', src: '/earwitness/E6f.jpg', flex: 6, height: '500px' },
            { title: 'A packed courtroom at Toforest Johnson\'s 2019 hearing in Judge Pulliam\'s courtroom to determine whether Violet Ellison\'s secret reward payment amounted to prosecutorial misconduct.', src: '/earwitness/E6g.jpg', flex: 12, height: '500px' },
            { title: 'Toforest consults with attorneys Kathryn Miller and Katherine Moss in Judge Pulliam\'s courtroom in 2019; attorneys Patrick Mulvaney (l) and Ty Alper (r) are in the background', src: '/earwitness/E6h.jpg', flex: 12, height: '500px' },
            { title: 'Toforest and attorney Kathryn Miller at his 2019 hearing', src: '/earwitness/E6i.jpg', flex: 12, height: '500px' },
            { title: 'Violet Ellison takes the stand at Toforest Johnson\'s 2019 court hearing', src: '/earwitness/E6j.jpg', flex: 12, height: '500px' },
            { title: 'The Alabama Judicial Building in Montgomery, housing both the state Supreme Court and Court of Criminal Appeals. Both courts have denied relief to Toforest Johnson.', src: '/earwitness/E6k.jpg', flex: 12, height: '500px' },
            { title: 'The judges of the Alabama Court of Criminal Appeals', src: '/earwitness/E6l.jpg', flex: 12, height: '500px' },
         ],
         'S1E7': [
           { title: 'Murika Wilson at her home in Birmingham, 2022', src: '/earwitness/E7a.jpg', flex: 6, height: '500px' },
           { title: 'Violet Ellison is listed on court documents as a witness for the State at Murika Wilson\'s murder trial', src: '/earwitness/E7b.jpg', flex: 6, height: '500px' },
           { title: 'The judge in Murika Wilson\'s murder trial makes a note in the case file, indicating that she has been acquitted and released', src: '/earwitness/E7c.jpg', flex: 6, height: '500px' },
         ],
         'S1E8': [
           { title: 'Toforest Johnson in an undated photo taken during a prison visit with (L-R) his mother, Donna, his daughter Shanaye Poole, and son Tremaine Perry', src: '/earwitness/E8a.jpg', flex: 6, height: '500px' },
           { title: 'Toforest Johnson in an undated photo taken during a prison visit with (L-R) his daughter Shanaye Poole, daughter Akeriya Lawler, and son Tremaine Perry', src: '/earwitness/E8b.jpg', flex: 6, height: '500px' },
           { title: 'Toforest Johnson in an undated photo taken during a prison visit with his mother, Donna Johnson', src: '/earwitness/E8c.jpg', flex: 6, height: '500px' },
           { title: 'Toforest Johnson in a photo taken during a prison visit with his mother, Donna and son, Tremaine Perry', src: '/earwitness/E8d.jpg', flex: 6, height: '500px' },
           { title: 'Toforest Johnson in an undated photo taken during a prison visit with his mother, Donna', src: '/earwitness/E8e.jpg', flex: 6, height: '500px' },
           { title: 'Four of Toforest\'s children (L-R) Akeriya Lawler, Maurice Myers, Shanaye Poole, Tremaine Perry, photographed in Birmingham, 2021', src: '/earwitness/E8f.jpg', flex: 6, height: '500px' },
           { title: 'Toforest Johnson in an undated photo taken during a prison visit with his sons (L-R), Maurice Myers and Tremaine Perry', src: '/earwitness/E8g.jpg', flex: 12, height: '500px' },
           { title: 'Toforest\'s son Robby Foster, with his family, 2021', src: '/earwitness/E8h.jpg', flex: 6, height: '500px' },
           { title: 'Toforest\'s daughter, Akeriya "Muffin" Lawler, reads one of the letters her dad sent her from prison to Beth, 2021', src: '/earwitness/E8i.jpg', flex: 6, height: '500px' },
           { title: 'One of many colorful envelopes Toforest sent his daughter, Akeriya "Muffin" Lawler, from prison', src: '/earwitness/E8j.jpg', flex: 12, height: '500px' },
           { title: 'A holiday card Toforest sent his daughter from prison when she was a child', src: '/earwitness/E8k.jpg', flex: 12, height: '500px' },
           { title: 'The banner sponsored by Greater Birmingham Ministries, hung on the front of their building, which faced the stadium hosting the 2021 World Games in Birmingham ', src: '/earwitness/E8l.jpg', flex: 6, height: '500px' },
           { title: 'The banner hung in front of the Highlands United Methodist Church at the kickoff for its tour of churches across the state of Alabama', src: '/earwitness/E8m.jpg', flex: 6, height: '500px' },
           { title: 'Newspaper clipping from 2021 about the widespread support for DA Danny Carr\'s call for a new trial for Toforest Johnson', src: '/earwitness/E8n.jpg', flex: 6, height: '500px' },
         ]
        },
        'war-on-drugs' : {
          'S1E11': [
            { title: '', src: '/war-on-drugs/E11a.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11b.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11c.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11d.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11e.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11f.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11g.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11h.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11i.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11j.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11k.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11l.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11m.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11n.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11o.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11p.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11q.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11r.jpg', flex: 6, height: '500px' },
            { title: '', src: '/war-on-drugs/E11s.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11t.jpg', flex: 12, height: '500px' },
            { title: '', src: '/war-on-drugs/E11u.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11v.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11w.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11x.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11y.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11z.jpg', flex: 12, height: '375px' },
            { title: '', src: '/war-on-drugs/E11zz.jpg', flex: 12, height: '500px' },
          ],
          'S2E0': [],
          'S2E1': [],
          'S2E2': []
        },
        'graves-county' : {
          'E0': [],
          'S3E1': [
            { title: 'Susan Galbreath, A KY housewife partnered with a news reporter to investigate the murder of an 18-year-old woman. See video <a href="https://www.youtube.com/watch?v=U8stcQP5x9w" target="_new">here</a>', src: '/graves-county/E1a.jpg', flex: 12, height: '500px' },
            { title: 'Susan Galbreath gets “Outstanding Citizen” award from the Kentucky Attorney general.', src: '/graves-county/E1b.jpg', flex: 6, height: '500px' },
            { title: 'Quincy Cross, currently serving life in prison without parole. <a href="https://freequincycross.com/" target="_new">Visit this site</a> to sign the release petition.', src: '/graves-county/E1c.jpg', flex: 12, height: '500px' },
            { title: 'Tamara Caldwell, convicted of manslaughter and abuse of corpse. Served almost six years.', src: '/graves-county/E1d.jpg', flex: 12, height: '500px' },
            { title: 'Victoria Caldwell, the state’s key witness in the trial against Quincy Cross.', src: '/graves-county/E1e.jpg', flex: 12, height: '500px' },
            { title: 'Susan Galbreath, received an “outstanding citizen” award from the Kentucky Attorney General’s office for her help solving Jessica Currin’s murder.', src: '/graves-county/E1f.jpg', flex: 12, height: '500px' },
            { title: 'Susan Galbreath’s first email to Tom Mangold.', src: '/graves-county/E1g.jpg', flex: 6, height: '500px' },
            { title: 'Darra shares with Maggie her collection of case documents.', src: '/graves-county/E1h.jpg', flex: 12, height: '500px' },
            { title: 'Hours are poured into reviewing and comparing documents to the current case.', src: '/graves-county/E1i.jpg', flex: 12, height: '500px' },
            { title: 'Darra\'s frustration is clear as more documents are explored.', src: '/graves-county/E1j.jpg', flex: 6, height: '500px' },
          ],
          'S3E2': [
            { title: 'Jessica Currin as a little girl.', src: '/graves-county/E2a.jpg', flex: 6, height: '500px' },
            { title: 'Jessica Currin’s gravesite at Oak Rest Cemetery in Mayfield.', src: '/graves-county/E2b.jpg', flex: 6, height: '500px' },
            { title: 'Maggie sits with Joe Currin to reflect on memories of his daughter, Jessica.', src: '/graves-county/E2c.jpg', flex: 12, height: '500px' },
            { title: 'The route of Jessica’s alleged walk.', src: '/graves-county/E2d.jpg', flex: 12, height: '500px' },
            { title: 'Vinisha Stubblefield takes the stand for her testimony.', src: '/graves-county/E2e.jpg', flex: 12, height: '500px' },
            { title: 'A portion of the first Myspace exchange between Susan Galbreath and Victoria Caldwell from January 2007.', src: '/graves-county/E2f.jpg', flex: 6, height: '500px' },
            { title: 'The fragment of a charred leather belt found near Jessica\'s at the crime scene.', src: '/graves-county/E2g.jpg', flex: 6, height: '500px' },
            { title: 'Newspaper headline announcing a body is found behind Mayfield Middle School.', src: '/graves-county/E2h.jpg', flex: 12, height: '500px' },
            { title: 'Report of Quincy’s arrest that Sunday morning.', src: '/graves-county/E2i.jpg', flex: 6, height: '500px' },

          ],
          'S3E3': [
            { title: 'Trial nears eight years after Jessica Currin’s death. News taken from The Courier-Journal, Louisville, Kentucky • Sun, Mar 2, 2008', src: '/graves-county/E3a.jpg', flex: 6, height: '500px' },
            { title: 'Jury convicts Quincy Cross on all counts. News clip taken from The Paducah Sun, Paducah, Kentucky • Wed, Apr 9, 2008', src: '/graves-county/E3b.jpg', flex: 6, height: '500px' },
            { title: 'David Cross, Quincy’s father, on his porch in Tennessee.', src: '/graves-county/E3c.jpg', flex: 6, height: '500px' },
            { title: 'Email from Susan Galbreath to Tom Mangold about finding Jeff Burton’s house.', src: '/graves-county/E3d.jpg', flex: 6, height: '500px' },
            { title: 'Jeff Burton being interrogated by the KBI.', src: '/graves-county/E3e.jpg', flex: 12, height: '500px' },
            { title: 'Quincy Cross being interrogated by the KBI.', src: '/graves-county/E3f.jpg', flex: 12, height: '500px' },
            { title: 'Tamara Caldwell being interrogated by the KBI.', src: '/graves-county/E3g.jpg', flex: 12, height: '500px' },
            { title: 'Victoria Caldwell being interrogated by the KBI.', src: '/graves-county/E3h.jpg', flex: 12, height: '500px' },
            { title: 'Vinisha Stubblefield being interrogated by the KBI.', src: '/graves-county/E3i.jpg', flex: 12, height: '500px' },
            { title: 'Mayfield Middle School viewed as Victoria Caldwell rides through Mayfield and the crime scene with the KBI agents.', src: '/graves-county/E3j.jpg', flex: 12, height: '500px' },
          ],
          'S3E4': [
            { title: "Clipping from The Mayfield Messenger, stating Jessica's Ex-boyfriend, Jeremy Adams, being indicted in the murder case." , src: '/graves-county/E4a.jpg', flex: 6, height: '500px' },
            { title: 'Cover of "ALMOST FRAMED-THE DIARY OF JEREMY ADAMS".', src: '/graves-county/E4b.jpg', flex: 6, height: '500px' },
            { title: 'The legal motion to vacate the conviction of Quincy Omar Cross. The motion, filed by the Kentucky Innocence Project ("KIP"), argues that Mr. Cross\'s conviction for the kidnapping, rape, and murder of Jessica Currin was wrongful and based on false and misleading evidence.', src: '/graves-county/E4c.jpg', flex: 6, height: '500px' },
            { title: 'LACEY GATES AFFIDAVIT - page 541 of KIP court filing - a motion to vacate a conviction, or alternatively, grant an evidentiary hearing, for Quincy Omar Cross. The motion is filed by the Kentucky Innocence Project. The affidavit states that Susan Galbreath\'s information was felt to be fraudulent and biased due to personal relations with the accused\'s family.', src: '/graves-county/E4d.jpg', flex: 6, height: '500px' },
            { title: 'Susan Galbreath\'s email to Tom, talking about her "friends" at the KBI', src: '/graves-county/E4e.jpg', flex: 12, height: '500px' },
            { title: 'State motion to vacate Quincy Cross\' conviction file by the Kentucky Innocence Project.', src: '/graves-county/E4f.jpg', flex: 6, height: '500px' },
            { title: 'Maggie talks with Rosie Crice, Victoria’s sister, while visiting Mayfield.', src: '/graves-county/E4g.jpg', flex: 6, height: '500px' },
            { title: 'Private investigator John Poole.', src: '/graves-county/E4h.jpg', flex: 6, height: '500px' },
            { title: 'Attorney Miranda Hellman, with the Kentucky Innocence Project.', src: '/graves-county/E4i.jpg', flex: 6, height: '500px' },
            { title: 'Jeremy Adams on the Steve Wilkos Show (<a href="https://www.facebook.com/TheSteveWilkosShow/videos/i-did-not-murder-her/482821932621230/" target="_new">video</a>)', src: '/graves-county/E4j.jpg', flex: 12, height: '500px' },
          ],
          'S3E5': [
            { title: 'Attorney Miranda Hellman, with the Kentucky Innocence Project.', src: '/graves-county/E5a.jpg', flex: 12, height: '500px' },
            { title: 'KBI Agent Lee Wise testifying at the 2008 trial of Quincy Cross.', src: '/graves-county/E5b.jpg', flex: 12, height: '500px' },
            { title: 'Rosie Crice takes the stand and gives her dramatic testimony for the defense in the Quincy Cross trial.', src: '/graves-county/E5c.jpg', flex: 6, height: '500px' },
            { title: 'A page from a Kentucky Innocence Project court filing including a receipt for a pink vibrator and batteries from a sex store in Durham, NC.', src: '/graves-county/E5d.jpg', flex: 6, height: '500px' },
            { title: '“Damn, they found the body.” The August 1st, 2000, diary entry that Victoria Caldwell read from at trial, and that she now says was fake.', src: '/graves-county/E5e.jpg', flex: 6, height: '500px' },
            { title: 'A page from a Kentucky Innocence Project court filing regarding Victoria Caldwell while in protective custody.', src: '/graves-county/E5f.jpg', flex: 6, height: '500px' },
            { title: 'Brenda Jackson and Noble Faulkner in their Mayfield home.', src: '/graves-county/E5g.jpg', flex: 12, height: '500px' },
          ],
          'S3E6': [
            { title: 'David Cross’ home in Tennessee.', src: '/graves-county/E6a.jpg', flex: 12, height: '500px' },
            { title: 'Quincy\'s dad David Cross sits on his porch in Tennessee', src: '/graves-county/E6b.jpg', flex: 6, height: '500px' },
            { title: 'Headline from Messanger newspaper "Lear Resigns his police job, heart not in it." March 29, 2001', src: '/graves-county/E6c.jpg', flex: 6, height: '500px' },
            { title: 'Ronnie Lear, former Assistant Chief of Police for the Mayfield Police Department.', src: '/graves-county/E6d.jpg', flex: 12, height: '375px' },
            { title: 'Mayfield Mayor accepts ex-policemen’s pleas. Clips from The Paducah Sun, July 12, 2002', src: '/graves-county/E6e.jpg', flex: 12, height: '375px' },
            { title: 'A list of the drugs allegedly found in Ronnie Lear’s desk after his resignation.', src: '/graves-county/E6f.jpg', flex: 12, height: '375px' },
            { title: 'Tom Mangold emails Susan Galbreath’s sister about the uncertain future of a film based on the duo.', src: '/graves-county/E6g.jpg', flex: 12, height: '500px' },
          ],
        },
        'bone-valley' : {
          'S1E1': [
            {
              title: 'The back of Judge Scott Cupp\'s business card, handed to Gilbert King at a conference in Naples, Florida, 2018.',
              src: '/bone-valley/E1a.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'The Honorable Judge Scott Cupp, Twentieth Judicial Circuit Court in Charlotte County, Florida. ',
              src: '/bone-valley/E1c.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Judge Scott Cupp is interviewed in Naples, Florida, by a crew for ABC News 20/20.',
              src: '/bone-valley/E1d.jpg',
              flex: 6,
              height: '500px'
            },
            {title: 'Michelle Saum, 1986(?)', src: '/bone-valley/E1e.jpg', flex: 6, height: '500px'},
            {title: 'Michelle Saum poses with a bicycle.', src: '/bone-valley/E1f.jpg', flex: 6, height: '500px'},
            {
              title: 'Leo Schofield\'s portrait from the Lake Gibson High School yearbook. ',
              src: '/bone-valley/E1g.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Michelle Schofield at her wedding reception, following her marriage to Leo. Southside Assembly of God, Lakeland, FL. August 29, 1986. ',
              src: '/bone-valley/E1h.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Leo and Michelle Schofield light a candle during their wedding ceremony at the Southside Assembly of God in Lakeland. August 29, 1986.',
              src: '/bone-valley/E1i.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Leo and Michelle Schofield pose for a photo at their wedding reception. Southside Assembly of God, Lakeland, FL. August 29, 1986.',
              src: '/bone-valley/E1j.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Michelle Schofield (center) stands with her best friend, Michell McCluskey, at Southside Assembly of God, Lakeland, FL. August 29, 1986.',
              src: '/bone-valley/E1k.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Leo and Michelle Schofield stand with a group of family and friends in front of their orange Mazda stationwagon.',
              src: '/bone-valley/E1l.jpg',
              flex: 6,
              height: '375px'
            },
            {
              title: 'Tom\'s Restaurant, where Michelle Schofield worked her waitressing shift the night she disappeared. Photographed 2018.',
              src: '/bone-valley/E1m.jpg',
              flex: 6,
              height: '375px'
            },
            {
              title: 'Missing person flyer featuring Michelle Schofield\'s photo and identifying information.',
              src: '/bone-valley/E1o.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Leo and Michelle Schofield\'s orange Mazda stationwagon, located along Interstate 4, February 26, 1987.',
              src: '/bone-valley/E1p.jpg',
              flex: 6,
              height: '500px'
            },
            //height is 500 or 375 flex is 12 or 6
          ],
          'S1E2': [
            {
              title: 'Two men kneel with the fossilized teeth of a mastodon, unearthed during phosphate mining, 1946. ',
              src: '/bone-valley/E2c.jpg',
              flex: 6,
              height: '375px'
            },
            {
              title: 'The Bigger Digger, world\'s largest dragline, mining phosphate in Florida\'s "Bone Valley," along Peace River. February 1948.',
              src: '/bone-valley/E2g.jpg',
              flex: 6,
              height: '375px'
            },
            {
              title: 'Leo Schofield talks to investigators alongside Interstate-4, where Michelle\'s Mazda stationwagon had been located. February 26, 1987.',
              src: '/bone-valley/E2l.jpg',
              flex: 6,
              height: '375px'
            },
            {
              title: 'The orange Mazda is photographed at the Florida Department of Law Enforcement\'s Orlando Crime Lab, where it was towed for inspection.',
              src: '/bone-valley/E2p.jpg',
              flex: 6,
              height: '375px'
            },
            {
              title: 'Aerial photo taken by helicopter, showing the canal where Michelle Schofield\'s body was found. February 27, 1987. ',
              src: '/bone-valley/E2r.jpg',
              flex: 12,
              height: '500px'
            },
            {title: '', src: '/bone-valley/E2s.jpg', flex: 12, height: '500px'},
            {
              title: 'Crime scene tape is tied to a sign along SR-33 that reads "NO DUMPING OF RUBBISH."',
              src: '/bone-valley/E2ii.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'The Polk County Sheriff\'s Office helicopter sits alongside State Road 33, across from the location where Michelle\'s body was discovered. ',
              src: '/bone-valley/E2aa.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Michelle Schofield\'s body is found floating face down, partially covered with a plywood board.',
              src: '/bone-valley/E2w.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Michelle\'s body and the plywood covering it can be seen at the edge of the canal, in the center of photo.',
              src: '/bone-valley/E2v.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Detectives from the Polk County Sheriff\'s Office stand at the scene where Michelle\'s body was found.',
              src: '/bone-valley/E2y.jpg',
              flex: 6,
              height: '500px'
            },
            {title: '', src: '/bone-valley/E2z.jpg', flex: 6, height: '500px'},
            {
              title: 'Leo Schofield is photographed pacing along the side of State Road 33, after the discovery of his wife\'s body. When prompted with this photo, Leo explains: "That man right there is totally lost."',
              src: '/bone-valley/E2gg.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Leo Sr\'s blue pickup truck parked alongside State Road 33.',
              src: '/bone-valley/E2hh.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Michelle Schofield\'s jacket is laid out and photographed at the scene where her body was discovered.',
              src: '/bone-valley/E2dd.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The plywood that was found covering Michelle\'s body, now kept in the evidence room beneath the Polk County courthouse.',
              src: '/bone-valley/E2oo.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The bloodstained top Michelle Schofield was wearing the night she was killed.',
              src: '/bone-valley/E2rr.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The Downy Fabric Softener bottle found in the back of the orange Mazda stationwagon with a smear of Michelle Schofield\'s blood.',
              src: '/bone-valley/E2ss.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Photograph of Michelle Schofield\'s top, taken the day her body was discovered. ',
              src: '/bone-valley/E2uu.jpg',
              flex: 6,
              height: '500px'
            },
            {title: 'Sheriff Grady Judd of Polk County.', src: '/bone-valley/E2vv.jpg', flex: 6, height: '500px'},
            {
              title: 'June 1988, nearly 16 months after Michelle Schofield is killed, her husband Leo is charged with the crime. ',
              src: '/bone-valley/E2yy.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E3': [
            {title: '', src: '/bone-valley/E3a.jpg', flex: 12, height: '500px'},
            {title: '', src: '/bone-valley/E3b.jpg', flex: 6, height: '500px'},
            {title: '', src: '/bone-valley/E3c.jpg', flex: 6, height: '500px'},
            {title: 'Portrait of Leo Schofield, Sr.', src: '/bone-valley/E3d.jpg', flex: 6, height: '500px'},
            {
              title: 'A letter from Leo Schofield to his family, written while he awaited trial in the Polk County jail.',
              src: '/bone-valley/E3e.jpg',
              flex: 6,
              height: '500px'
            },
            {title: '', src: '/bone-valley/E3f.jpg', flex: 12, height: '500px'},
            {title: '', src: '/bone-valley/E3g.jpg', flex: 12, height: '375px'},
            {
              title: 'Leo and Michelle Schofield\'s neighborhood is photographed from the air.',
              src: '/bone-valley/E3h.jpg',
              flex: 12,
              height: '500px'
            },
            {title: '', src: '/bone-valley/E3i.jpg', flex: 12, height: '500px'},
            {title: '', src: '/bone-valley/E3j.jpg', flex: 6, height: '500px'},
            {title: '', src: '/bone-valley/E3k.jpg', flex: 6, height: '500px'},
            {title: '', src: '/bone-valley/E3l.jpg', flex: 12, height: '500px'},
            {
              title: 'Michelle Schofield, buried with her maiden name Saum, Oak Hill Burial Park, Lakeland, Florida. Michelle\'s surname was changed following the conviction of her husband for her murder. ',
              src: '/bone-valley/E3m.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E4': [
            {
              title: 'Leo Schofield stands in the prison yard and shows off his arm, tattooed with an electric guitar.',
              src: '/bone-valley/E4a.jpg',
              flex: 6,
              height: '500px'
            },
            {title: 'Leo and Crissie Carter Schofield.', src: '/bone-valley/E4b.jpg', flex: 6, height: '500px'},
            {
              title: 'The orange Mazda stationwagon, as it was found in February 1987 -- broken down and abandoned along Interstate-4.',
              src: '/bone-valley/E4c.jpg',
              flex: 12,
              height: '375px'
            },
            {title: 'Fingerprints on the hood of the Mazda.', src: '/bone-valley/E4d.jpg', flex: 12, height: '375px'},
            {
              title: 'Fingerprints lifted from the interior driver\'s side window of the orange Mazda stationwagon. These prints remained unidentified until they were finally run through the statewide AFIS system in December 2004.',
              src: '/bone-valley/E4e.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Rolled fingerprints taken from Jeremy Scott after he was charged with arson in 1985. These prints were manually compared to those lifted from the Mazda in 1987, to validate the AFIS findings. The prints are a match.',
              src: '/bone-valley/E4f.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Mugshot of Jeremy Scott, the man who left fingerprints in Michelle Schofield\'s Mazda stationwagon.',
              src: '/bone-valley/E4g.jpg',
              flex: 6,
              height: '500px'
            },
          ],
          'S1E5': [
            {
              title: 'The Polk Tribune, covering the 1985 trial of Jeremy Scott for the murder of Jewel Johnson. ',
              src: '/bone-valley/E5a.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Following Jeremy Scott\'s acquittal in the murder of Jewel Johnson, the State Attorney\'s Office pursued charges of arson. Jeremy\'s public defender filed a motion alleging prosecutorial misconduct, which described Jeremy as "extremely emotionally disturbed." Jeremy was eventually convicted on the charge, and sent to an adult state prison. ',
              src: '/bone-valley/E5b.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'The Tampa Tribune, published September 8, 1989. ',
              src: '/bone-valley/E5c.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Jeremy Scott is resentenced, and removed from death row. The Tampa Tribune, published November 6, 1992. ',
              src: '/bone-valley/E5d.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Mugshot of Larry Brian Hall, Jeremy Scott\'s co-defendent in the 1988 murder of Donald Morehead. ',
              src: '/bone-valley/E5e.jpg',
              flex: 6,
              height: '500px'
            },
            {title: 'Jeremy Scott.', src: '/bone-valley/E5f.jpg', flex: 6, height: '500px'},
            {title: 'Jeremy Scott.', src: '/bone-valley/E5g.jpg', flex: 6, height: '500px'},
            {title: 'Jeremy Scott.', src: '/bone-valley/E5h.jpg', flex: 6, height: '500px'},
          ],
          'S1E6': [
            {
              title: 'The Tampa Tribune, published April 13, 1987.',
              src: '/bone-valley/E6a.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Contact sheet showing images of Joseph Lavair\'s taxi cab, including the Confederate flag baseball cap that was left in the back seat when the suspect fled the scene of the crash.  ',
              src: '/bone-valley/E6b.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Contact sheet showing photos of the cab\'s interior.',
              src: '/bone-valley/E6c.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'The baseball cap left in the cab by the suspect, emblazoned with a skull and Confederate flag.',
              src: '/bone-valley/E6d.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'A crime scene technician\'s sketch of the baseball cap, a key piece of evidence.',
              src: '/bone-valley/E6e.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Composite sketch created from the statements of multiple witnesses who saw the suspect fleeing the scene of the crashed taxi cab.',
              src: '/bone-valley/E6f.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Another suspect sketch, created from witness statements.',
              src: '/bone-valley/E6g.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'A diagram showing the route the taxi cab travelled before crashing into a utility pole and knocking out power in Intercession City.',
              src: '/bone-valley/E6h.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The Orlando Sentinel, published April 18, 1987. Caption printed beneath the picture: "Buddy Shepherd (left), Larry Taggett and Jim Wells guard Daniel Otte after he was arrested by Osceola County deputies Friday and charged with the murder of a Kissimmee taxicab driver." ',
              src: '/bone-valley/E6i.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Mugshot of Daniel Otte following his arrest in the murder of Joseph Lavair.',
              src: '/bone-valley/E6j.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The Orlando Sentinel covers the trial of Daniel Otte.',
              src: '/bone-valley/E6k.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The Orlando Sentinel, published October 21, 1987.',
              src: '/bone-valley/E6l.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E7': [
            {
              title: 'The War Room at Hardee Correctional Institution, where inmates pray and conduct "spiritual warfare."',
              src: '/bone-valley/E7a.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The interior of Hardee C.I.\'s War Room, where Leo knelt and prayed for Jeremy Scott.',
              src: '/bone-valley/E7b.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'A letter to Jeremy Scott, written by Leo Schofield\'s attorney, Andrew Crawford. ',
              src: '/bone-valley/E7c.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Jeremy Scott writes back to Andrew Crawford: "who really know what happen that night. the state don\'t, you don\'t. help me, I help you... I die with this information" ',
              src: '/bone-valley/E7d.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Excerpt from notes taken by Andrew Crawford\'s colleague, Sean Costis, who witnessed the call between Crawford and Jeremy Scott, during which Jeremy confessed to the murder of Michelle Schofield. ',
              src: '/bone-valley/E7e.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Another letter from Jeremy Scott, written to Andrew Crawford: "I Jeremy Lynn Scott killed Mrs. Schofield... it time to end all this."',
              src: '/bone-valley/E7f.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Leo and his wife Crissie smile and pose with their daughter, Ashley. ',
              src: '/bone-valley/E7g.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Leo\'s daughter, Ashley, shows off her new tattoo, matching her father\'s.   ',
              src: '/bone-valley/E7h.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Transcription of Jeremy Scott\'s recorded confession to the murder of Michelle Schofield.',
              src: '/bone-valley/E7i.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The Tampa Tribune, published August 23, 1997. Assitant State Attorney John Aguero is removed from his position as the director of homicide by his boss, State Attorney Jerry Hill. Hill said, "It is my plan to give him a breather, then we\'ll put him back in the game. But it would not bother me to see John take a year off. He\'s a terrific resource, and we\'re doing our part to take care of that resource."',
              src: '/bone-valley/E7j.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Assitant State Attorney John Aguero sits in the Polk County jail after being charged with domestic battery following an argument with his wife in May 2011. Reports published in the Lakeland Ledger state that the couple was divorcing, and had been drinking throughout the day. ',
              src: '/bone-valley/E7k.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Leo Schofield is directed by a bailiff in the Polk County Courthouse on the first day of his evidentiary hearing, October 12, 2017.  ',
              src: '/bone-valley/E7l.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Jeremy Scott, handcuffed, is sworn in prior to his testimony at the evidentiary hearing in October 2017. ',
              src: '/bone-valley/E7m.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Jeremy Scott stands at a podium to testify during the October 2017 evidentiary hearing. Throughout his testimony, Jeremy maintained that he alone killed Michelle Schofield. ',
              src: '/bone-valley/E7n.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Seth Miller (left), of the Innocence Project of Florida, and Andrew Crawford sit and listen to the State\'s presentation during the October 2017 evidentiary hearing. Miller and Crawford both serve as co-counsel for Leo Schofield.',
              src: '/bone-valley/E7o.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Leo sits with his face in his hands during the hearing. ',
              src: '/bone-valley/E7p.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Assistant State Attorney Victoria Avalon shows Jeremy Scott photos from Michelle Schofield\'s autopsy during the 2017 evidentiary hearing. ',
              src: '/bone-valley/E7q.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'The Tampa Bay Times, published October 13, 2017. Journalist Anastasia Dawson characterizes Jeremy Scott\'s statement -- "I didn\'t do that" -- as a recantation, despite Jeremy\'s following testimony in which he maintained his confession to Michelle Schofield\'s murder. ',
              src: '/bone-valley/E7r.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E8': [
            {
              title: 'Gilbert King stands and talks to Leo Schofield\'s wife, Crissie, and daughter, Ashley, outside the room where a hearing before the 2nd District Court of Appeals will be held. The hearing was held on September 25, 2019, to determine whether the lower court made the correct ruling, following a 2017 evidentiary hearing.  ',
              src: '/bone-valley/E8a.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Crissie Carter Schofield and Ashley Schofield talk about their expectations for the 2nd DCA hearing, and their recent visits to Hardee Correctional Institution, to visit Leo.',
              src: '/bone-valley/E8b.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Leo\'s attorney, Seth Miller of the Innoncence Project of Florida, shares his impressions of the panel of three judges, following his oral arguments. ',
              src: '/bone-valley/E8c.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Politcal advertisement published in the Tampa Tribune, promoting Jerry Hill\'s campaign for State Attorney of the 10th Circuit, which incluses Polk, Highlands, and Hardee counties. Hill won the election, and would hold the post of State Attorney for over three decades. ',
              src: '/bone-valley/E8d.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The Lakeland Ledger announces the retirement of State Attorney Jerry Hill. The position of 10th Circuit State Attorney is now held by Brian Haas. ',
              src: '/bone-valley/E8e.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'A letter written by Michelle Schofield\'s brother, Jessie Saum, in support of Leo Schofield\'s parole. This letter was never presented to the parole board. ',
              src: '/bone-valley/E8f.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Crissie Carter Schofield\'s letter in support of her husband\'s parole. ',
              src: '/bone-valley/E8g.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Jeremy Scott\'s first letter to Gilbert King.',
              src: '/bone-valley/E8h.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Another letter from Jeremy Scott to Gilbert King. In this letter, Jeremy reveals some incriminating (and unsolicited) details about the murder of a taxi cab driver. ',
              src: '/bone-valley/E8i.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'A lengthy letter from Jeremy Scott, with a detailed account of the murder of Michelle Schofield.',
              src: '/bone-valley/E8j.jpg',
              flex: 6,
              height: '500px'
            },
          ],
          'S1E9': [
            {
              title: 'The entry sign for Martin Correctional Institution in Indiantown, Florida, where Gilbert and Kelsey arrived to interview Jeremy Scott.',
              src: '/bone-valley/E9a.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Photograph taken by the Polk County Sheriff\'s Office at the scene where Michelle Schofield\'s body was discovered on February 27, 1987. The trash photographed here was never collected by crime scene technicians and examined for blood or fingerprints.',
              src: '/bone-valley/E9b.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'A discarded pack of Marlboro cigarettes photographed by the Polk County Sheriff\'s Office at the scene where Michelle Schofield\'s body was discovered on February 27, 1987. Although photographed like evidence, this item was never collected and tested for physical evidence.',
              src: '/bone-valley/E9c.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Leo Schofield (left) poses with his band, The Watchers.',
              src: '/bone-valley/E9d.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Leo Schofield (right) poses with his band, The Watchers.',
              src: '/bone-valley/E9e.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Leo Schofield (right) poses with his friend, cellmate, and songwriting partner Kevin Herrick.',
              src: '/bone-valley/E9g.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Leo and his daughter Ashley perform together alongside The Watchers at Hardee Correctional Institution.',
              src: '/bone-valley/E9f.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'A lion drawn by Leo Schofield, gifted to Judge Scott Cupp. ',
              src: '/bone-valley/E9h.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Gilbert King and Judge Scott Cupp stand in front of Leo\'s French Toast House in Alva, Florida.',
              src: '/bone-valley/E9i.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Gilbert stands with boxes of documents filled with Leo Schofield\'s case files in March, 2019. ',
              src: '/bone-valley/E9j.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Gilbert and Kelsey take a photo outside the Phosphate Musuem in Mulberry, Florida.',
              src: '/bone-valley/E9m.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Gilbert and Kelsey pose with Polk County Sheriff Grady Judd following his interview for Bone Valley.',
              src: '/bone-valley/E9k.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Gilbert is interviewed by ABC 20/20 for their episode, "Last Seen in Lakeland."',
              src: '/bone-valley/E9l.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E10': [
            {
              title: 'Gilbert and Kelsey set off in the rental car to meet up with Judge Scott Cupp.',
              src: '/bone-valley/E10a.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Gilbert and Kelsey are reunited with Judge Cupp.',
              src: '/bone-valley/E10b.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Kelsey interviews Judge Cupp about his expectations for the day while standing in a Publix Super Market parking lot.',
              src: '/bone-valley/E10c.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'Gilbert and Judge Cupp talk during the drive to Hardee Correctional Insititution.',
              src: '/bone-valley/E10d.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'A portrait of a lion -- created for and gifted to Judge Scott Cupp by Leo Schofield.',
              src: '/bone-valley/E10e.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'The entrance sign for Hardee Correctional Institution.',
              src: '/bone-valley/E10f.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Gilbert stands beside a phosphate mining dragline bucket outside the Phosphate Museum in Mulberry, Florida.',
              src: '/bone-valley/E10g.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Judge Cupp shows off the shirt he wore into the prison for his visitation with Leo. The shirt reads: "Keep Judge Scott Cupp Hendry County Judge."',
              src: '/bone-valley/E10h.jpg',
              flex: 6,
              height: '500px'
            },
            {
              titcle: 'A lighthouse, drawn by Leo Schofield, that now hangs in Gilbert\'s office. Leo titled the drawing, "The Way Home"',
              src: '/bone-valley/E10i.jpg',
              flex: 6,
              height: '500px'
            },
          ],
          'S1E11': [
            {title: 'Leo at Hardee Correctional Institution', src: '/bone-valley/E11a.jpg', flex: 6, height: '500px'},
            {
              title: 'Leo and his songwriting partner, Kevin Herrick, with their guitars.',
              src: '/bone-valley/E11b.jpg',
              flex: 6,
              height: '500px'
            },
          ],
          'S1E12': [
            {
              title: 'Pastor Tony Parker giving a tour of Noah Community Outreach.',
              src: '/bone-valley/E12a.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Crissie revs the Harley-Davidson motorcycle that\'s waiting for Leo in her garage.',
              src: '/bone-valley/E12b.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Scott Cupp and Gilbert visit with Florida Senator Jonathan Martin, center, in his Tallahassee office.',
              src: '/bone-valley/E12c.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E13': [
            {
              title: 'Brittany Spangler, Kelsey Decker, and Kara Kornhaber working on Nothing but a Meatball.',
              src: '/bone-valley/E13a.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Gilbert holding one of Leo\'s grandsons at the pre-parole dinner.',
              src: '/bone-valley/E13b.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Crissie, Ashley, her two sons, and the family of Leo\'s bandmate, Kevin Herrick at the pre-parole dinner.',
              src: '/bone-valley/E13c.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Commissioners David Wyant and Richard Davison shortly before the Leo\'s parole hearing begins.',
              src: '/bone-valley/E13d.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E15': [
            {
              title: 'Scott Cupp, Gilbert King, Dr. Regina B. Shearn, Leo Schofield, and Senator Jonathan Martin at a CTP banquet in July.',
              src: '/bone-valley/E15a.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Everglades Correctional Institution',
              src: '/bone-valley/E15b.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S1E17': [
            {
              title: 'Leo shares a long awaited hug with Kelsey',
              src: '/bone-valley/E17a.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Gilbert, Kara, and Kelsey share a moment with Leo after his release',
              src: '/bone-valley/E17b.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Crissie takes a selfie with Leo in the Tesla',
              src: '/bone-valley/E17c.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Stopping for gas along the Tamiami Trail, Leo and Gilbert share a moment',
              src: '/bone-valley/E17d.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'In Tampa with Leo\'s adoptive father, Dave, and his sister Pam',
              src: '/bone-valley/E17e.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'In Tampa, Leo begins to play Sunset Micki, a song he wrote 37 years ago for his wife, Michelle ',
              src: '/bone-valley/E17f.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'At daybreak, Crissie and Leo pictured with Leo\'s sister Tammy, and his niece, Jasmine who flew in from Idaho for Leo\'s walkout',
              src: '/bone-valley/E17g.jpg',
              flex: 12,
              height: '375px'
            },
            {
              title: 'At 6:00 am in rain, Leo leaves prison property in the black Tesla',
              src: '/bone-valley/E17h.jpg',
              flex: 12,
              height: '375px'
            },
          ],
          'S2E0': [],
          'S2E1': [
            {
              title: 'Jami’s 1987 high school yearbook photo.',
              src: '/bone-valley/S2E1a.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Justin as a young man.',
              src: '/bone-valley/S2E1b.jpg',
              flex: 5,
              height: '500px'
            },
            {
              title: 'The teen dance club in Lakeland where Jami first met Jeremy.',
              src: '/bone-valley/S2E1c.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Sign outside the Green Parrot Bar in Lakeland, where Jeremy was known to assault customers in the parking lot.',
              src: '/bone-valley/S2E1d.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Justin being interviewed in 2024. ',
              src: '/bone-valley/S2E1e.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The car Jeremy stole from murder victim Donald Moorhead.',
              src: '/bone-valley/S2E1f.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Lakeland Mall: Jeremy would hang out in the parking lot of the Lakeland Mall.',
              src: '/bone-valley/S2E1g.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S2E2': [
            {
              title: 'Jennifer Stone saw this headline in the Lakeland Ledger and notified police. ',
              src: '/bone-valley/S2E2a.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'The Esprit bottle of sparkling white grape juice Jeremy struck Donald Moorhead with. ',
              src: '/bone-valley/S2E2b.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The cassette used to record Jeremy’s confession. ',
              src: '/bone-valley/S2E2c.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The telephone cord Jeremy used to strangle Moorhead. ',
              src: '/bone-valley/S2E2d.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'The Esprit bottle of sparkling white grape juice Jeremy struck Donald Moorhead with. ',
              src: '/bone-valley/S2E2e.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Jeremy’s T-shirt.',
              src: '/bone-valley/S2E2f.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Sketches depicting fatal injuries to Donald Moorhead. ',
              src: '/bone-valley/S2E2g.jpg',
              flex: 6,
              height: '500px'
            },
            {
              title: 'Bloody chair at murder scene.',
              src: '/bone-valley/S2E2h.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'The telephone cord Jeremy used to strangle Moorhead. ',
              src: '/bone-valley/S2E2i.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'The note Jeremy’s accomplice, Brian Hall, left on Moorhead’s door. It reads: Friend was in trouble in Orlando. Went to help him. Be back in a few days. Don',
              src: '/bone-valley/S2E2j.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Donald Moorhead’s trailer—the scene of the murder.',
              src: '/bone-valley/S2E2k.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Jeremy’s mugshot after his arrest for Moorhead’s murder.',
              src: '/bone-valley/S2E2l.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'Jeremy convicted in the murder of Donald Moorhead. ',
              src: '/bone-valley/S2E2m.jpg',
              flex: 12,
              height: '500px'
            },
            {
              title: 'The Florida Supreme Court overturned Jeremy’s death sentence in 1992.',
              src: '/bone-valley/S2E2n.jpg',
              flex: 12,
              height: '500px'
            },
          ],
          'S2E3': [
            {
              title: 'The Jpay message Jeremy sent to Gilbert just hours before the attack. ',
              src: '/bone-valley/S2E3a.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'Redacted Critical Incident Summary from Jeremy’s assault.',
              src: '/bone-valley/S2E3b.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'Description of Incident at Wakulla Annex. ',
              src: '/bone-valley/S2E3c.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'Oscar visited with Jeremy weekly during the summer of 2024 at Florida State Prison. ',
              src: '/bone-valley/S2E3d.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Jeremy Scott at Florida State Prison in 2024.',
              src: '/bone-valley/S2E3e.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'The cemetery at Florida State Prison in Raiford, Fl.',
              src: '/bone-valley/S2E3f.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'Gravestones at the cemetery are marked with the deceased inmate’s name, prison number, and date of death.',
              src: '/bone-valley/S2E3g.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'The plates are made in the prison’s license tag plant, which produces all of Florida’s official vehicle tags. ',
              src: '/bone-valley/S2E3h.jpg',
              flex: 6,
              height: '500px'
            },
          ],
          'S2E4': [
            {
              title: 'Osceola County Sheriff’s Office composite sketch of the man believed to be Joseph Lavair’s killer.',
              src: '/bone-valley/S2E4a.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Osceola County Sheriff’s Office composite sketch of the man believed to be Joseph Lavair’s killer. ',
              src: '/bone-valley/S2E4b.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'The taxicab stolen by the murderer of Joseph Lavair. ',
              src: '/bone-valley/S2E4c.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'One week after Lavair’s murder, Buddy Shephard (left) arrested Dan Otte (on ground) in Polk County.',
              src: '/bone-valley/S2E4d.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Detective Buddy Shephard.',
              src: '/bone-valley/S2E4e.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Dan Otte stood trial twice for Lavair’s murder, and was finally acquitted in October 1987. ',
              src: '/bone-valley/S2E4f.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Joseph Lavair’s murderer was believed to have left this hat behind in the taxicab. ',
              src: '/bone-valley/S2E4g.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Jeremy sent Gilbert a six-page letter confessing in detail to Lavair’s murder, and drew this detailed map, documenting the taxicab’s path before crashing, and the direction he took while fleeing the scene. ',
              src: '/bone-valley/S2E4h.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'Gilbert meets with Buddy Shephard, the former detective who investigated the murder of Joseph Lavair, as Buddy’s dog, Cujo looks on. ',
              src: '/bone-valley/S2E4i.jpg',
              flex: 6,
              height: '500px'
            },
          ],
          'S2E5': [
            {
              title: 'Jeremy E-gram: An E-gram photo Jeremy sent to Meri in February, 2025.',
              src: '/bone-valley/S2E5a.jpg',
              flex: 12,
              height: '375px'
            }, {
              title: 'Meri West: Meri West, a housecleaner in Northern Florida, began corresponding with Jeremy shortly after listening to Bone Valley Season 1.',
              src: '/bone-valley/S2E5b.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Letter Jeremy sent to Meri.',
              src: '/bone-valley/S2E5c.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Letter Jeremy sent to Meri.',
              src: '/bone-valley/S2E5d.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Letter Jeremy sent to Meri.',
              src: '/bone-valley/S2E5e.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Letter Jeremy sent to Meri.',
              src: '/bone-valley/S2E5f.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Mother’s Day: A hand drawn Mother’s Day card Jeremy sent to Meri.',
              src: '/bone-valley/S2E5g.jpg',
              flex: 6,
              height: '500px'
            }
          ],
          'S2E6': [
            {
              title: 'Leo showed up at the Polk Theater in Lakeland in December, 2024 for a talk Gilbert was doing, and took questions from the audience.  ',
              src: '/bone-valley/S2E6a.jpg',
              flex: 12,
              height: '375px'
            }, {
              title: 'After the talk, Leo met with Bone Valley fans for selfies and conversation. ',
              src: '/bone-valley/S2E6b.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'In January 2025, Leo and his daughter Ashley were involved in a motorcycle accident, with both suffering serious injuries.  ',
              src: '/bone-valley/S2E6c.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Since the accident, Leo has been confined to a hospital bed in his living room in Tampa. ',
              src: '/bone-valley/S2E6d.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'ASA Victoria Avalon shows Jeremy Scott a photograph from Michelle Schofield’s autopsy at the 2017 evidentiary hearing, where Jeremy confessed to killing Michelle. ',
              src: '/bone-valley/S2E6e.jpg',
              flex: 12,
              height: '500px'
            }, {
              title: 'The prison outside Tallahassee, Florida where Jeremy is currently incarcerated.',
              src: '/bone-valley/S2E6f.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Justin as a young man.  ',
              src: '/bone-valley/S2E6g.jpg',
              flex: 6,
              height: '500px'
            }, {
              title: 'Leo, Crissie, Ashley, and the Leo’s three grandsons at their Tampa home in March, 2025. ',
              src: '/bone-valley/S2E6h.jpg',
              flex: 6,
              height: '500px'
            }
          ]
        }
      },
  }),
  methods: {
    getHeight: function(height) {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return height - 150
        default : return height
      }
    },
    getVideoHeight: function(height) {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return height - 110
        default : return height
      }
    },
    getVideoWidth: function(width) {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return width - 195
        default : return width
      }
    },
  },
}
</script>
